import { jsx as e, jsxs as d, Fragment as le } from "react/jsx-runtime";
import { Button as de, Flex as N, Box as w, defineStyleConfig as G, createMultiStyleConfigHelpers as Se, defineStyle as R, extendTheme as Ce, Text as b, Stack as ne, useTheme as Ke, FormControl as Ae, InputGroup as xe, InputLeftElement as Dt, Image as Je, Input as De, FormLabel as Ze, FormHelperText as zt, FormErrorMessage as ze, HStack as O, Skeleton as Pe, Badge as Yt, VStack as ce, Divider as se, Radio as _e, Select as Wt, useDisclosure as qt, RadioGroup as Vt, AlertDialog as Xt, AlertDialogOverlay as Ot, AlertDialogContent as Kt, AlertDialogHeader as Jt, AlertDialogBody as Zt, AlertDialogFooter as Qt, useBreakpointValue as er, Heading as tr, Spinner as rr, IconButton as pt } from "@chakra-ui/react";
import bt, { createContext as or, useContext as nr, useState as L, useEffect as K, useRef as re, useMemo as te, useCallback as W, forwardRef as We, useId as ar } from "react";
import { checkboxAnatomy as Be } from "@chakra-ui/anatomy";
import { AnimatePresence as ir, motion as gt } from "framer-motion";
import { createPortal as lr } from "react-dom";
import { CloseIcon as sr, ChevronDownIcon as dr, DeleteIcon as cr, AddIcon as pr, ChevronLeftIcon as br, ChevronRightIcon as gr } from "@chakra-ui/icons";
import { formatPrice as ve } from "@getjust/commons";
import { Controller as Ht } from "react-hook-form";
import ut from "currency.js";
import ur from "react-phone-number-input";
import { useDebouncedCallback as mr } from "use-debounce";
const He = ({
  label: t,
  variant: r,
  onClick: a,
  Icon: o,
  imageProps: n,
  trackingId: l,
  ...c
}) => {
  const p = r === "aurora";
  return /* @__PURE__ */ e(
    de,
    {
      variant: r,
      onClick: a,
      gap: 1.5,
      p: r === "aurora" ? "2px" : 0,
      ...c,
      className: "loading-container",
      "data-ph-capture-attribute-tracking-id": l,
      children: /* @__PURE__ */ d(
        N,
        {
          bgColor: p ? "var(--card-bg, #FFF)" : "transparent",
          borderRadius: p ? "28px" : "none",
          w: "full",
          h: "full",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.375rem",
          children: [
            o ? bt.isValidElement(o) ? o : bt.createElement(o) : null,
            t,
            r === "skeleton" && /* @__PURE__ */ e(w, { className: "loading-bar", animation: "loadingAnimation 1800ms 0ms infinite" })
          ]
        }
      )
    }
  );
};
He.defaultProps = {
  border: "md",
  variant: "primary",
  isLoading: !1
};
const Fr = G({
  // The styles all Box have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "black.900"
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), hr = G({
  // The styles all Buttons have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "white",
      backgroundColor: "buttonBlack.900",
      _hover: {
        backgroundColor: "buttonBlack.500"
      },
      _active: {
        backgroundColor: "buttonBlack.900"
      },
      _loading: {
        backgroundColor: "buttonBlack.900 !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    },
    secondary: {
      color: "gray.701",
      backgroundColor: "gray.602",
      _hover: {
        backgroundColor: "gray.602"
      },
      _active: {
        backgroundColor: "gray.602"
      },
      _loading: {
        backgroundColor: "gray.602 !important",
        color: "#FFF !important"
      }
    },
    disabled: {
      color: "gray.603",
      backgroundColor: "gray.601",
      _hover: {
        backgroundColor: "gray.601"
      },
      _active: {
        backgroundColor: "gray.601"
      },
      _loading: {
        backgroundColor: "gray.601 !important",
        color: "#FFF !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
      _hover: {
        backgroundColor: "buttonBlack.500"
      },
      _active: {
        backgroundColor: "buttonBlack.900"
      },
      _loading: {
        backgroundColor: "buttonBlack.900 !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Ne, defineMultiStyleConfig: fr } = Se(Be.keys), yr = {
  md: Ne({
    control: R({
      h: "20px",
      w: "20px"
    }),
    label: R({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Ne({
    control: R({
      h: "16px",
      w: "16px"
    }),
    label: R({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, xr = Ne({
  label: {
    color: "#8F8F8F",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#585858",
      borderColor: "#585858",
      _hover: {
        bg: "#585858",
        borderColor: "#585858"
      }
    }
  }
}), vr = fr({ baseStyle: xr, sizes: yr }), Sr = R({
  borderWidth: "1px",
  borderStyle: "dashed"
}), Cr = G({
  variants: { dashed: Sr }
}), mt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, ge = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Br = G({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...mt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...mt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Er = {
  border: "1px solid",
  borderColor: "gray.602",
  color: "fullBlack.900",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3"
}, Qe = {
  p: "1px",
  borderRadius: "1.875rem"
}, et = {
  bgGradient: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bg: ""
}, tt = {
  bg: "danger.main !important",
  bgGradient: ""
}, rt = {
  bg: "gray.602 !important",
  bgGradient: ""
}, ot = {
  bg: "gray.602 !important",
  bgGradient: ""
}, nt = {
  bgGradient: "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), var(--input-bg, #FFF) !important",
  bg: ""
}, at = {
  bg: "var(--input-bg, #FFF) !important",
  bgGradient: ""
}, it = {
  bg: "var(--input-bg, #FFF)",
  bgGradient: ""
}, lt = {
  bg: "var(--input-bg, #FFF)",
  bgGradient: ""
}, jt = {
  bg: "var(--input-bg, #FFF) !important",
  opacity: 1,
  color: "gray.701 !important"
}, kr = {
  bg: "var(--input-bg, #FFF)"
}, st = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bgImage: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bgClip: "border-box"
}, wr = {
  boxShadow: "0 0 0 30px #F5FBFB inset !important",
  WebkitBoxShadow: "0 0 0 30px #F5FBFB inset !important",
  MozBoxShadow: "0 0 0 30px #F5FBFB inset !important"
}, Ft = {
  ...Er,
  _disabled: jt,
  _focusVisible: kr,
  _autofill: wr
}, Ir = G({
  variants: {
    just: {
      field: {
        ...Ft
      }
    },
    justUnstyled: {
      field: {
        ...Ft,
        _focusVisible: {
          boxShadow: "transprarent !important",
          bgGradient: "transprarent !important",
          bg: "#FFF !important"
        },
        _invalid: {
          boxShadow: "#FFF !important",
          bgGradient: "#FFF !important",
          bg: "#FFF !important"
        },
        border: "#FFF !important",
        bgGradient: "#FFF !important",
        bg: "#FFF !important"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "just"
  }
}), _r = G({
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), Ut = Ce({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: hr,
    Divider: Cr,
    Form: Br,
    Input: Ir,
    Radio: _r,
    Box: Fr,
    Checkbox: vr
  },
  themedClasses: {
    inputBackgroundDisabledStyle: at,
    inputBackgroundEmptyStyle: it,
    inputBackgroundGradientStyle: nt,
    inputBackgroundInvalidStyle: lt,
    inputBorderDisabledStyle: ot,
    inputBorderEmptyStyle: rt,
    inputBorderGradientStyle: et,
    inputBorderInvalidStyle: tt,
    inputBorderStyle: Qe,
    inputBoxShadowGradientStyle: st
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#282525",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F7F7F7",
      602: "#E0E0E0",
      603: "#8F8F8F",
      701: "#585858",
      801: "#1C1C1C"
    },
    danger: {
      main: "#EE5829",
      text: "#EE5829"
    },
    focus: {
      main: "#0F4C8F",
      error: "#E9553A"
    }
  }
}), Ar = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#3D3D3D",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "white"
  },
  defaultProps: {
    variant: "primary"
  }
}), Dr = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#3D3D3D",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#1C1C1C",
      background: "#FFFFFF",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "#FFFFFF !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    },
    secondary: {
      color: "#FFFFFF",
      backgroundColor: "#585858",
      _hover: {
        backgroundColor: "#6B6B6B"
      },
      _active: {
        backgroundColor: "#4A4A4A"
      },
      _loading: {
        backgroundColor: "#585858 !important",
        color: "#FFFFFF !important"
      }
    },
    disabled: {
      color: "#8F8F8F",
      backgroundColor: "#3D3D3D",
      _hover: {
        backgroundColor: "#3D3D3D"
      },
      _active: {
        backgroundColor: "#3D3D3D"
      },
      _loading: {
        backgroundColor: "#3D3D3D !important",
        color: "#8F8F8F !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "#FFFFFF",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "#FFFFFF !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Ye, defineMultiStyleConfig: zr } = Se(Be.keys), Wr = {
  md: Ye({
    control: R({
      h: "20px",
      w: "20px"
    }),
    label: R({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Ye({
    control: R({
      h: "16px",
      w: "16px"
    }),
    label: R({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, Hr = Ye({
  label: {
    color: "#B0B0B0",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    borderColor: "#585858",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#FFFFFF",
      borderColor: "#FFFFFF",
      color: "#1C1C1C",
      _hover: {
        bg: "#E0E0E0",
        borderColor: "#E0E0E0"
      }
    }
  }
}), jr = zr({ baseStyle: Hr, sizes: Wr }), Ur = R({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#585858"
}), $r = G({
  baseStyle: {
    borderColor: "#585858"
  },
  variants: { dashed: Ur }
}), ht = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, ue = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Gr = G({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...ht
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ht,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Tr = {
  border: "1px solid",
  borderColor: "gray.700",
  color: "#FFFFFF",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#262323"
}, Rr = {
  p: "1px",
  borderRadius: "1.875rem"
}, Lr = {
  bg: "#585858",
  bgGradient: ""
}, Mr = {
  bg: "danger.main !important",
  bgGradient: ""
}, Pr = {
  bg: "#585858 !important",
  bgGradient: ""
}, Nr = {
  bg: "#3D3D3D !important",
  bgGradient: ""
}, Yr = {
  bg: "#262323 !important",
  bgGradient: ""
}, qr = {
  bg: "#1C1C1C !important",
  bgGradient: ""
}, Vr = {
  bg: "#262323",
  bgGradient: ""
}, Xr = {
  bg: "#262323",
  bgGradient: ""
}, Or = {
  bg: "#1C1C1C !important",
  opacity: 0.6,
  color: "#8F8F8F !important"
}, Kr = {
  bg: "#262323",
  borderColor: "#FFFFFF"
}, Jr = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "rgba(255, 255, 255, 0.3)",
  bgClip: "border-box"
}, Zr = {
  boxShadow: "0 0 0 30px #262323 inset !important",
  WebkitBoxShadow: "0 0 0 30px #262323 inset !important",
  MozBoxShadow: "0 0 0 30px #262323 inset !important",
  WebkitTextFillColor: "#FFFFFF !important"
}, ft = {
  ...Tr,
  _disabled: Or,
  _focusVisible: Kr,
  _autofill: Zr
}, Qr = G({
  variants: {
    just: {
      field: {
        ...ft
      }
    },
    justUnstyled: {
      field: {
        ...ft,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#262323 !important"
        },
        _invalid: {
          boxShadow: "#262323 !important",
          bgGradient: "#262323 !important",
          bg: "#262323 !important"
        },
        border: "#262323 !important",
        bgGradient: "#262323 !important",
        bg: "#262323 !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), eo = G({
  baseStyle: {
    control: {
      borderColor: "#585858",
      _checked: {
        bg: "#FFFFFF",
        borderColor: "#FFFFFF",
        color: "#1C1C1C",
        _before: {
          bg: "#1C1C1C"
        },
        _hover: {
          bg: "#E0E0E0",
          borderColor: "#E0E0E0"
        }
      }
    },
    label: {
      color: "#FFFFFF"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), to = Ce({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.3), 0px 1px 18px rgba(0, 0, 0, 0.2), 0px 3px 5px rgba(0, 0, 0, 0.25)"
  },
  components: {
    Button: Dr,
    Divider: $r,
    Form: Gr,
    Input: Qr,
    Radio: eo,
    Box: Ar,
    Checkbox: jr
  },
  themedClasses: {
    inputBackgroundDisabledStyle: qr,
    inputBackgroundEmptyStyle: Vr,
    inputBackgroundGradientStyle: Yr,
    inputBackgroundInvalidStyle: Xr,
    inputBorderDisabledStyle: Nr,
    inputBorderEmptyStyle: Pr,
    inputBorderGradientStyle: Lr,
    inputBorderInvalidStyle: Mr,
    inputBorderStyle: Rr,
    inputBoxShadowGradientStyle: Jr
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#3D3D3D",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#3D3D3D",
      602: "#585858",
      603: "#8F8F8F",
      700: "#585858",
      701: "#B0B0B0",
      801: "#FFFFFF"
    },
    danger: {
      main: "#FF6B6B",
      text: "#FF6B6B"
    },
    focus: {
      main: "#6BB3FF",
      error: "#FF6B6B"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#1C1C1C",
      secondary: "#262323",
      card: "#262323"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#B0B0B0",
      muted: "#8F8F8F"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#1C1C1C",
        color: "#FFFFFF"
      }
    }
  }
}), ro = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#E0E0E0",
      color: "#999999"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#000000"
  },
  defaultProps: {
    variant: "primary"
  }
}), oo = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#E0E0E0",
      color: "#999999"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#555555",
      background: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF",
        borderColor: "#000000"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#E0E0E0 !important",
        fontSize: "1.5rem",
        color: "#555555 !important"
      }
    },
    secondary: {
      color: "#000000",
      backgroundColor: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        backgroundColor: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        backgroundColor: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        backgroundColor: "#E0E0E0 !important",
        color: "#000000 !important"
      }
    },
    disabled: {
      color: "#999999",
      backgroundColor: "#E0E0E0",
      _hover: {
        backgroundColor: "#E0E0E0"
      },
      _active: {
        backgroundColor: "#E0E0E0"
      },
      _loading: {
        backgroundColor: "#E0E0E0 !important",
        color: "#999999 !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#555555",
      borderRadius: "28px",
      background: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#E0E0E0 !important",
        fontSize: "1.5rem",
        color: "#555555 !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: qe, defineMultiStyleConfig: no } = Se(Be.keys), ao = {
  md: qe({
    control: R({
      h: "20px",
      w: "20px"
    }),
    label: R({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: qe({
    control: R({
      h: "16px",
      w: "16px"
    }),
    label: R({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, io = qe({
  label: {
    color: "#666666",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1.5px",
    borderColor: "#E0E0E0",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "var(--button-active-bg, #000000)",
      borderColor: "var(--button-active-bg, #000000)",
      color: "var(--button-active-text, #FFFFFF)",
      _hover: {
        bg: "var(--button-active-bg, #333333)",
        borderColor: "var(--button-active-bg, #333333)"
      }
    }
  }
}), lo = no({ baseStyle: io, sizes: ao }), so = R({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#E0E0E0"
}), co = R({
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "#000000"
}), po = G({
  baseStyle: {
    borderWidth: "1px",
    borderColor: "#000000"
  },
  variants: { dashed: so, solid: co }
}), yt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, me = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, bo = G({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...yt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...yt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), go = {
  border: "1px solid",
  borderColor: "#E0E0E0",
  color: "#000000",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#FFFFFF"
}, uo = {
  p: "1px",
  borderRadius: "1.875rem"
}, mo = {
  bg: "#000000",
  bgGradient: ""
}, Fo = {
  bg: "danger.main !important",
  bgGradient: ""
}, ho = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, fo = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, yo = {
  bg: "#FFFFFF !important",
  bgGradient: ""
}, xo = {
  bg: "#F5F5F5 !important",
  bgGradient: ""
}, vo = {
  bg: "#FFFFFF",
  bgGradient: ""
}, So = {
  bg: "#FFFFFF",
  bgGradient: ""
}, Co = {
  bg: "#F5F5F5 !important",
  opacity: 0.6,
  color: "#999999 !important"
}, Bo = {
  bg: "#FFFFFF",
  borderColor: "#999999"
}, Eo = {
  borderRadius: "1.875rem",
  filter: "var(--input-focus-blur, blur(4px))",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "var(--input-focus-shadow-bg, rgba(0, 0, 0, 0.15))",
  bgClip: "border-box"
}, ko = {
  boxShadow: "0 0 0 30px #FFFFFF inset !important",
  WebkitBoxShadow: "0 0 0 30px #FFFFFF inset !important",
  MozBoxShadow: "0 0 0 30px #FFFFFF inset !important",
  WebkitTextFillColor: "#000000 !important"
}, xt = {
  ...go,
  _disabled: Co,
  _focusVisible: Bo,
  _autofill: ko
}, wo = G({
  variants: {
    just: {
      field: {
        ...xt
      }
    },
    justUnstyled: {
      field: {
        ...xt,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#FFFFFF !important"
        },
        _invalid: {
          boxShadow: "#FFFFFF !important",
          bgGradient: "#FFFFFF !important",
          bg: "#FFFFFF !important"
        },
        border: "#FFFFFF !important",
        bgGradient: "#FFFFFF !important",
        bg: "#FFFFFF !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), Io = G({
  baseStyle: {
    control: {
      borderColor: "#E0E0E0",
      _checked: {
        bg: "#000000",
        borderColor: "#000000",
        color: "#FFFFFF",
        _before: {
          bg: "#FFFFFF"
        },
        _hover: {
          bg: "#333333",
          borderColor: "#333333"
        }
      }
    },
    label: {
      color: "#000000"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), vt = Ce({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: oo,
    Divider: po,
    Form: bo,
    Input: wo,
    Radio: Io,
    Box: ro,
    Checkbox: lo
  },
  themedClasses: {
    inputBackgroundDisabledStyle: xo,
    inputBackgroundEmptyStyle: vo,
    inputBackgroundGradientStyle: yo,
    inputBackgroundInvalidStyle: So,
    inputBorderDisabledStyle: fo,
    inputBorderEmptyStyle: ho,
    inputBorderGradientStyle: mo,
    inputBorderInvalidStyle: Fo,
    inputBorderStyle: uo,
    inputBoxShadowGradientStyle: Eo
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#F5F5F5",
      500: "#E0E0E0",
      900: "#000000"
    },
    buttonBlack: {
      50: "#999999",
      500: "#E0E0E0",
      900: "#000000"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F5F5F5",
      602: "#E0E0E0",
      603: "#999999",
      700: "#000000",
      701: "#666666",
      801: "#000000"
    },
    danger: {
      main: "#EE5829",
      text: "#C74931"
    },
    focus: {
      main: "#000000",
      error: "#EE5829"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#FFFFFF",
      secondary: "#F5F5F5",
      card: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#666666",
      muted: "#999999"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#FFFFFF",
        color: "#000000"
      }
    }
  }
}), _o = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#1C1C1C"
  },
  defaultProps: {
    variant: "primary"
  }
}), Ao = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "white",
      backgroundColor: "rgba(28, 28, 28, 0.9)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.18)",
      _hover: {
        backgroundColor: "rgba(28, 28, 28, 0.8)"
      },
      _active: {
        backgroundColor: "rgba(28, 28, 28, 1)"
      },
      _loading: {
        backgroundColor: "rgba(28, 28, 28, 0.9) !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    },
    secondary: {
      color: "gray.701",
      backgroundColor: "rgba(224, 224, 224, 0.6)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)",
      _hover: {
        backgroundColor: "rgba(224, 224, 224, 0.8)"
      },
      _active: {
        backgroundColor: "rgba(224, 224, 224, 0.7)"
      },
      _loading: {
        backgroundColor: "rgba(224, 224, 224, 0.6) !important",
        color: "#585858 !important"
      }
    },
    disabled: {
      color: "gray.603",
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      _hover: {
        backgroundColor: "rgba(247, 247, 247, 0.6)"
      },
      _active: {
        backgroundColor: "rgba(247, 247, 247, 0.6)"
      },
      _loading: {
        backgroundColor: "rgba(247, 247, 247, 0.6) !important",
        color: "#8F8F8F !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "linear-gradient(90deg, rgba(141, 230, 144, 0.8) 2.08%, rgba(165, 240, 163, 0.8) 18.23%, rgba(166, 236, 215, 0.8) 33.33%, rgba(151, 218, 218, 0.8) 51.56%, rgba(179, 218, 231, 0.8) 67.71%, rgba(182, 201, 236, 0.8) 83.33%, rgba(135, 154, 203, 0.8) 100%)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "linear-gradient(90deg, rgba(141, 230, 144, 0.8) 2.08%, rgba(165, 240, 163, 0.8) 18.23%, rgba(166, 236, 215, 0.8) 33.33%, rgba(151, 218, 218, 0.8) 51.56%, rgba(179, 218, 231, 0.8) 67.71%, rgba(182, 201, 236, 0.8) 83.33%, rgba(135, 154, 203, 0.8) 100%) !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Ve, defineMultiStyleConfig: Do } = Se(Be.keys), zo = {
  md: Ve({
    control: R({
      h: "20px",
      w: "20px"
    }),
    label: R({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Ve({
    control: R({
      h: "16px",
      w: "16px"
    }),
    label: R({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, Wo = Ve({
  label: {
    color: "#585858",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    borderColor: "rgba(224, 224, 224, 0.8)",
    bg: "rgba(255, 255, 255, 0.5)",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "rgba(88, 88, 88, 0.9)",
      borderColor: "rgba(88, 88, 88, 0.9)",
      _hover: {
        bg: "rgba(88, 88, 88, 0.8)",
        borderColor: "rgba(88, 88, 88, 0.8)"
      }
    }
  }
}), Ho = Do({ baseStyle: Wo, sizes: zo }), jo = R({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "rgba(224, 224, 224, 0.6)"
}), Uo = G({
  baseStyle: {
    borderColor: "rgba(224, 224, 224, 0.6)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)"
  },
  variants: { dashed: jo }
}), St = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, Fe = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, $o = G({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...Fe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Fe,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...St
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...St,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...Fe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Fe,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...Fe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Fe,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium",
          borderRadius: "4px",
          px: "2px"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Go = {
  border: "1px solid",
  borderColor: "rgba(224, 224, 224, 0.6)",
  color: "fullBlack.900",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)"
}, To = {
  p: "1px",
  borderRadius: "1.875rem"
}, Ro = {
  bg: "rgba(224, 224, 224, 0.6)",
  bgGradient: ""
}, Lo = {
  bg: "danger.main !important",
  bgGradient: ""
}, Mo = {
  bg: "rgba(224, 224, 224, 0.6) !important",
  bgGradient: ""
}, Po = {
  bg: "rgba(224, 224, 224, 0.4) !important",
  bgGradient: ""
}, No = {
  bg: "rgba(255, 255, 255, 0.85) !important",
  bgGradient: "",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)"
}, Yo = {
  bg: "rgba(255, 255, 255, 0.5) !important",
  bgGradient: ""
}, qo = {
  bg: "rgba(255, 255, 255, 0.7)",
  bgGradient: ""
}, Vo = {
  bg: "rgba(255, 255, 255, 0.7)",
  bgGradient: ""
}, Xo = {
  bg: "rgba(255, 255, 255, 0.5) !important",
  opacity: 0.8,
  color: "gray.701 !important"
}, Oo = {
  bg: "rgba(255, 255, 255, 0.9)",
  boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.6)"
}, Ko = {
  borderRadius: "1.875rem",
  filter: "blur(8px)",
  content: '""',
  position: "absolute",
  top: "-2px",
  right: "-2px",
  bottom: "-2px",
  left: "-2px",
  bg: "rgba(255, 255, 255, 0.4)",
  bgClip: "border-box"
}, Jo = {
  boxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important",
  WebkitBoxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important",
  MozBoxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important"
}, Ct = {
  ...Go,
  _disabled: Xo,
  _focusVisible: Oo,
  _autofill: Jo
}, Zo = G({
  variants: {
    just: {
      field: {
        ...Ct
      }
    },
    justUnstyled: {
      field: {
        ...Ct,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "rgba(255, 255, 255, 0.7) !important"
        },
        _invalid: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "rgba(255, 255, 255, 0.7) !important"
        },
        border: "transparent !important",
        bgGradient: "transparent !important",
        bg: "rgba(255, 255, 255, 0.7) !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), Qo = G({
  baseStyle: {
    control: {
      borderColor: "rgba(224, 224, 224, 0.8)",
      bg: "rgba(255, 255, 255, 0.5)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      _checked: {
        bg: "rgba(88, 88, 88, 0.9)",
        borderColor: "rgba(88, 88, 88, 0.9)",
        _before: {
          w: "calc(50% + 1px)",
          h: "calc(50% + 1px)"
        },
        _hover: {
          bg: "rgba(88, 88, 88, 0.8)",
          borderColor: "rgba(88, 88, 88, 0.8)"
        }
      }
    },
    label: {
      color: "#1C1C1C"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), en = Ce({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 4px 6px rgba(0, 0, 0, 0.05), 0px 1px 12px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.06)"
  },
  components: {
    Button: Ao,
    Divider: Uo,
    Form: $o,
    Input: Zo,
    Radio: Qo,
    Box: _o,
    Checkbox: Ho
  },
  themedClasses: {
    inputBackgroundDisabledStyle: Yo,
    inputBackgroundEmptyStyle: qo,
    inputBackgroundGradientStyle: No,
    inputBackgroundInvalidStyle: Vo,
    inputBorderDisabledStyle: Po,
    inputBorderEmptyStyle: Mo,
    inputBorderGradientStyle: Ro,
    inputBorderInvalidStyle: Lo,
    inputBorderStyle: To,
    inputBoxShadowGradientStyle: Ko
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#282525",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "rgba(247, 247, 247, 0.8)",
      602: "rgba(224, 224, 224, 0.6)",
      // Increase contrast for glassy (avoid "grey on grey")
      603: "#5F5F5F",
      701: "#2F2F2F",
      801: "#111111"
    },
    danger: {
      main: "#EE5829",
      text: "#EE5829"
    },
    focus: {
      main: "#0F4C8F",
      error: "#E9553A"
    },
    // Theme-specific semantic colors
    background: {
      primary: "transparent",
      secondary: "rgba(255, 255, 255, 0.7)",
      card: "rgba(255, 255, 255, 0.7)"
    },
    text: {
      primary: "#111111",
      secondary: "#2F2F2F",
      muted: "#5F5F5F"
    }
  },
  styles: {
    global: {
      body: {
        bg: "transparent",
        color: "#111111"
      }
    }
  }
}), tn = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#F0F0F0",
      color: "#888888"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#000000"
  },
  defaultProps: {
    variant: "primary"
  }
}), rn = G({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#F0F0F0",
      color: "#888888"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#888888",
      background: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF",
        borderColor: "#000000"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#F0F0F0 !important",
        fontSize: "1.5rem",
        color: "#888888 !important"
      }
    },
    secondary: {
      color: "#000000",
      backgroundColor: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        backgroundColor: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        backgroundColor: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        backgroundColor: "#F0F0F0 !important",
        color: "#000000 !important"
      }
    },
    disabled: {
      color: "#888888",
      backgroundColor: "#F0F0F0",
      _hover: {
        backgroundColor: "#F0F0F0"
      },
      _active: {
        backgroundColor: "#F0F0F0"
      },
      _loading: {
        backgroundColor: "#F0F0F0 !important",
        color: "#888888 !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#888888",
      borderRadius: "28px",
      background: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#F0F0F0 !important",
        fontSize: "1.5rem",
        color: "#888888 !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Xe, defineMultiStyleConfig: on } = Se(Be.keys), nn = {
  md: Xe({
    control: R({
      h: "20px",
      w: "20px"
    }),
    label: R({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Xe({
    control: R({
      h: "16px",
      w: "16px"
    }),
    label: R({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, an = Xe({
  label: {
    color: "#555555",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1.5px",
    borderColor: "#D0D0D0",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#000000",
      borderColor: "#000000",
      color: "#FFFFFF",
      _hover: {
        bg: "#333333",
        borderColor: "#333333"
      }
    }
  }
}), ln = on({ baseStyle: an, sizes: nn }), sn = R({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#eeeeee"
}), dn = R({
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "#eeeeee"
}), cn = G({
  baseStyle: {
    borderWidth: "1px",
    borderColor: "#eeeeee"
  },
  variants: { dashed: sn, solid: dn }
}), Bt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, he = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, pn = G({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...he
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...he,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...Bt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Bt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...he
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...he,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...he
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...he,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), bn = {
  border: "1.5px solid",
  borderColor: "#E0E0E0",
  color: "#000000",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#F0F0F0"
}, gn = {
  p: "1px",
  borderRadius: "1.875rem"
}, un = {
  bg: "#BEBBB4",
  bgGradient: ""
}, mn = {
  bg: "danger.main !important",
  bgGradient: ""
}, Fn = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, hn = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, fn = {
  bg: "#F0F0F0 !important",
  bgGradient: ""
}, yn = {
  bg: "#F7F7F7 !important",
  bgGradient: ""
}, xn = {
  bg: "#F0F0F0",
  bgGradient: ""
}, vn = {
  bg: "#F0F0F0",
  bgGradient: ""
}, Sn = {
  bg: "#F7F7F7 !important",
  opacity: 0.6,
  color: "#888888 !important"
}, Cn = {
  bg: "#F0F0F0",
  borderColor: "#BEBBB4"
}, Bn = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "rgba(190, 187, 180, 0.3)",
  bgClip: "border-box"
}, En = {
  boxShadow: "0 0 0 30px #F0F0F0 inset !important",
  WebkitBoxShadow: "0 0 0 30px #F0F0F0 inset !important",
  MozBoxShadow: "0 0 0 30px #F0F0F0 inset !important",
  WebkitTextFillColor: "#000000 !important"
}, Et = {
  ...bn,
  _disabled: Sn,
  _focusVisible: Cn,
  _autofill: En
}, kn = G({
  variants: {
    just: {
      field: {
        ...Et
      }
    },
    justUnstyled: {
      field: {
        ...Et,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#F0F0F0 !important"
        },
        _invalid: {
          boxShadow: "#F0F0F0 !important",
          bgGradient: "#F0F0F0 !important",
          bg: "#F0F0F0 !important"
        },
        border: "#F0F0F0 !important",
        bgGradient: "#F0F0F0 !important",
        bg: "#F0F0F0 !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), wn = G({
  baseStyle: {
    control: {
      borderColor: "#BEBBB4",
      _checked: {
        bg: "#000000",
        borderColor: "#000000",
        color: "#FFFFFF",
        _before: {
          bg: "#FFFFFF"
        },
        _hover: {
          bg: "#333333",
          borderColor: "#333333"
        }
      }
    },
    label: {
      color: "#000000"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), In = Ce({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: rn,
    Divider: cn,
    Form: pn,
    Input: kn,
    Radio: wn,
    Box: tn,
    Checkbox: ln
  },
  themedClasses: {
    inputBackgroundDisabledStyle: yn,
    inputBackgroundEmptyStyle: xn,
    inputBackgroundGradientStyle: fn,
    inputBackgroundInvalidStyle: vn,
    inputBorderDisabledStyle: hn,
    inputBorderEmptyStyle: Fn,
    inputBorderGradientStyle: un,
    inputBorderInvalidStyle: mn,
    inputBorderStyle: gn,
    inputBoxShadowGradientStyle: Bn
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#F0F0F0",
      500: "#DEDCDC",
      900: "#BEBBB4"
    },
    buttonBlack: {
      50: "#888888",
      500: "#F0F0F0",
      900: "#000000"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F7F7F7",
      602: "#E0E0E0",
      603: "#888888",
      700: "#BEBBB4",
      701: "#555555",
      801: "#000000"
    },
    danger: {
      main: "#EE5829",
      text: "#C74931"
    },
    focus: {
      main: "#BEBBB4",
      error: "#EE5829"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#DEDCDC",
      secondary: "#F0F0F0",
      card: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#555555",
      muted: "#888888"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#DEDCDC",
        color: "#000000"
      }
    }
  }
}), _n = ["aurora", "black", "glassy", "soft", "classic", "custom"], dt = "aurora", kt = {
  aurora: Ut,
  black: to,
  glassy: en,
  soft: In,
  classic: vt,
  custom: vt
}, wt = {
  aurora: {
    "--bg": "#ffffff",
    "--bg-secondary": "#F7F7F7",
    "--text": "#1C1C1C",
    "--text-secondary": "#585858",
    "--text-muted": "#8F8F8F",
    "--tooltip-text": "#1C1C1C",
    "--tooltip-bg": "var(--success, #63DD51)",
    "--border": "#E0E0E0",
    "--input-bg": "#ffffff",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--border-gradient": "linear-gradient(90deg, rgb(141, 230, 144) 2.08%, rgb(165, 240, 163) 18.23%, rgb(166, 236, 215) 33.33%, rgb(151, 218, 218) 51.56%, rgb(179, 218, 231) 67.71%, rgb(182, 201, 236) 83.33%, rgb(135, 154, 203) 100%)",
    "--badge-border-bg": "var(--chakra-colors-gray-100)",
    "--card-bg": "#FFF",
    "--card-bg-gradient": "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #ffffff",
    "--button-primary-bg": "#1C1C1C",
    "--button-primary-text": "#ffffff",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#1C1C1C",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "#F6BCFF",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "#000",
    // Upsell carousel
    "--upsell-card-bg": "#ffffff",
    "--upsell-card-bg-active": "linear-gradient(90deg, rgba(141, 230, 144, 0.05) 2.08%, rgba(165, 240, 163, 0.05) 18.23%, rgba(166, 236, 215, 0.05) 33.33%, rgba(151, 218, 218, 0.05) 51.56%, rgba(179, 218, 231, 0.05) 67.71%, rgba(182, 201, 236, 0.05) 83.33%, rgba(135, 154, 203, 0.05) 100%), #FFF",
    "--upsell-border-active": "#8DE690",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "linear-gradient(90deg, #8DE690 0%, #A5F0A3 20%, #A6ECD7 40%, #97DADA 60%, #B3DAE7 80%, #879ACB 100%)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#1C1C1C",
    "--upsell-text": "var(--text, #1C1C1C)",
    "--upsell-icon": "var(--text, #1C1C1C)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#ffffff",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--input-border-empty": "var(--chakra-colors-gray-602)",
    "--input-border-disabled": "var(--chakra-colors-gray-602)",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #ffffff",
    "--input-bg-empty": "#ffffff",
    "--input-bg-error-message": "#fff",
    "--input-bg-disabled": "#ffffff",
    "--input-bg-invalid": "#ffffff",
    "--input-disabled-bg-variant": "#F7F7F7",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--loading-skeleton-color": "rgba(255, 255, 255, 0.10)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--bg)",
    "--shipping-expanded-bg": "var(--bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)"
  },
  black: {
    "--bg": "#1C1C1C",
    "--bg-secondary": "#262323",
    "--text": "#FFFFFF",
    "--tooltip-text": "#1C1C1C",
    "--tooltip-bg": "var(--success, #88F878)",
    "--text-secondary": "#B0B0B0",
    "--text-muted": "#8F8F8F",
    "--badge-border-bg": "#1C1C1C",
    "--card-bg": "#262323",
    "--border": "#585858",
    "--input-bg": "#262323",
    "--input-border": "#585858",
    "--input-focus-border": "#FFFFFF",
    "--border-gradient": "#B0B0B0",
    "--card-bg-gradient": "#262323",
    "--button-primary-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--button-primary-text": "#1C1C1C",
    "--danger": "#FF6B6B",
    "--success": "#88F878",
    "--badge-text": "#1C1C1C",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "#88F878",
    "--badge-success-bg-gradient": "var(--button-primary-bg)",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "#FFFFFF",
    "--offset-shadow": "2px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "var(--text-muted)",
    // Upsell carousel
    "--upsell-card-bg": "var(--card-bg, #262323)",
    "--upsell-card-bg-active": "linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%), #262323",
    "--upsell-border-active": "var(--border, #585858)",
    "--upsell-border-default": "#3D3D3D",
    "--upsell-btn-bg-active": "var(--border, #585858)",
    "--upsell-btn-bg-delete": "var(--card-bg, #262323)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--upsell-text": "var(--text, #FFFFFF)",
    "--upsell-icon": "var(--text, #FFFFFF)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.75)",
    "--toast-bg": "var(--card-bg, #262323)",
    "--toast-border": "var(--border, #585858)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.30)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#585858",
    "--input-border-empty": "#585858",
    "--input-border-disabled": "#3D3D3D",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-error-message": "#1C1C1C",
    "--input-bg-filled": "#262323",
    "--input-bg-empty": "#262323",
    "--input-bg-disabled": "#1C1C1C",
    "--input-bg-invalid": "#262323",
    "--input-disabled-bg-variant": "#1C1C1C",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(255, 255, 255, 0.3)",
    "--loading-skeleton-color": "transparent",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--bg)",
    "--shipping-expanded-bg": "var(--bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)"
  },
  glassy: {
    "--bg": "transparent",
    "--bg-secondary": "rgba(255, 255, 255, 0.7)",
    "--text": "#111111",
    "--tooltip-text": "#111111",
    "--tooltip-bg": "var(--success, #63DD51)",
    "--text-secondary": "#2F2F2F",
    "--text-muted": "#5F5F5F",
    "--card-bg": "rgba(255, 255, 255, 0.8)",
    "--badge-border-bg": "rgba(255, 255, 255, 0.8)",
    "--border": "rgba(224, 224, 224, 0.6)",
    "--input-bg": "rgba(255, 255, 255, 0.7)",
    "--input-border": "rgba(224, 224, 224, 0.6)",
    "--input-focus-border": "rgba(255, 255, 255, 0.9)",
    "--border-gradient": "rgba(0, 0, 0, 0.12)",
    "--card-bg-gradient": "transparent",
    "--button-primary-bg": "rgba(28, 28, 28, 0.9)",
    "--button-primary-text": "#ffffff",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#111111",
    "--badge-border": "1px solid var(--border)",
    "--badge-success-bg-solid": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "none",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "rgba(255, 255, 255, 0.5)",
    "--offset-shadow": "2px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "#000",
    // Upsell carousel
    "--upsell-card-bg": "var(--card-bg, rgba(255, 255, 255, 0.7))",
    "--upsell-card-bg-active": "var(--card-bg, rgba(255, 255, 255, 0.7))",
    "--upsell-border-active": "var(--border, #E0E0E0)",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "rgba(255, 255, 255, 0.65)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#1C1C1C",
    "--upsell-text": "var(--text, #1C1C1C)",
    "--upsell-icon": "var(--text, #1C1C1C)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "var(--bg-secondary, rgba(255, 255, 255, 0.7))",
    "--toast-border": "var(--border, rgba(224, 224, 224, 0.6))",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "rgba(224, 224, 224, 0.6)",
    "--input-border-empty": "rgba(224, 224, 224, 0.6)",
    "--input-border-disabled": "rgba(224, 224, 224, 0.4)",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "rgba(255, 255, 255, 0.85)",
    "--input-bg-empty": "rgba(255, 255, 255, 0.7)",
    "--input-bg-disabled": "rgba(255, 255, 255, 0.5)",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "rgba(255, 255, 255, 0.7)",
    "--input-disabled-bg-variant": "rgba(255, 255, 255, 0.5)",
    // Glassy-specific effects
    "--input-backdrop-filter": "blur(18px)",
    "--input-box-shadow-filled": "inset 0 1px 0 rgba(255, 255, 255, 0.55)",
    "--input-focus-blur": "blur(8px)",
    "--input-focus-shadow-bg": "rgba(255, 255, 255, 0.4)",
    "--loading-skeleton-color": "transparent",
    // Shipping section
    "--shipping-radio-unchecked": "rgba(0, 0, 0, 0.15)",
    "--shipping-radio-checked": "rgba(0, 0, 0, 0.55)",
    "--shipping-radio-inner": "rgba(255, 255, 255, 0.9)",
    "--shipping-expanded-bg": "var(--bg-secondary)",
    "--shipping-badge-cheapest": "var(--bg-secondary)",
    "--shipping-border-selected": "rgba(0, 0, 0, 0.08)"
  },
  soft: {
    "--bg": "#DEDCDC",
    "--bg-secondary": "#F0F0F0",
    "--bg-tertiary": "#BEBBB4",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#555555",
    "--text-muted": "#888888",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#BEBBB4",
    "--border": "#E0E0E0",
    "--input-bg": "#F0F0F0",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "#BEBBB4",
    "--border-gradient": "#BEBBB4",
    "--card-bg-gradient": "#FFFFFF",
    "--button-primary-bg": "#F0F0F0",
    "--button-primary-text": "#888888",
    "--button-active-bg": "#000000",
    "--button-active-text": "#FFFFFF",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#000000",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "#BEBBB4",
    "--badge-quantity-bg": "#BEBBB4",
    "--badge-quantity-text": "#000000",
    "--accent-border": "#BEBBB4",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#888888",
    "--pay-button-bg-disabled": "#BEBBB4",
    "--pay-button-text-enabled": "#FFFFFF",
    "--pay-button-bg-enabled": "#000000",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-active": "#BEBBB4",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "#BEBBB4",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#000000",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#BEBBB4",
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#F0F0F0",
    "--input-bg-empty": "#F0F0F0",
    "--input-bg-disabled": "#F7F7F7",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#F0F0F0",
    "--input-disabled-bg-variant": "#F7F7F7",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(190, 187, 180, 0.3)",
    "--loading-skeleton-color": "rgba(255, 255, 255, 0.10)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)",
    // Input with icon
    "--input-icon-color": "#888888"
  },
  classic: {
    "--bg": "#FFFFFF",
    "--bg-secondary": "#F5F5F5",
    "--bg-tertiary": "#E0E0E0",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#666666",
    "--text-muted": "#999999",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#FFFFFF",
    "--border": "#E0E0E0",
    "--input-bg": "#FFFFFF",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "#000000",
    "--border-gradient": "#000000",
    "--card-bg-gradient": "#FFFFFF",
    "--button-primary-bg": "#E0E0E0",
    "--button-primary-text": "#555555",
    "--button-active-bg": "#000000",
    "--button-active-text": "#FFFFFF",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#FFFFFF",
    "--badge-border": "none",
    "--badge-success-bg-solid": "#000000",
    "--badge-success-bg-tint": "rgba(0, 0, 0, 0.18)",
    "--badge-success-bg-gradient": "#000000",
    "--badge-quantity-bg": "#000000",
    "--badge-quantity-text": "#FFFFFF",
    "--accent-border": "#000000",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#555555",
    "--pay-button-bg-disabled": "#E0E0E0",
    "--pay-button-text-enabled": "#FFFFFF",
    "--pay-button-bg-enabled": "#000000",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-active": "#000000",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "#000000",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#000000",
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#FFFFFF",
    "--input-bg-empty": "#FFFFFF",
    "--input-bg-disabled": "#F5F5F5",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#FFFFFF",
    "--input-disabled-bg-variant": "#F5F5F5",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(0, 0, 0, 0.15)",
    "--loading-skeleton-color": "rgba(0, 0, 0, 0.05)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "#000000",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-badge-cheapest": "#000000",
    "--shipping-border-selected": "#000000",
    "--shipping-border-selected-p": "1px",
    // Input with icon
    "--input-icon-color": "#000000"
  },
  custom: {
    "--bg": "#FFFFFF",
    "--bg-secondary": "#FFFFFF",
    "--bg-tertiary": "#E0E0E0",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#666666",
    "--text-muted": "#999999",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#FFFFFF",
    "--border": "#E0E0E0",
    "--input-bg": "#FFFFFF",
    "--input-border": "#E0E0E0",
    "--button-primary-bg": "#E0E0E0",
    "--button-primary-text": "#555555",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-border": "none",
    "--badge-success-bg-tint": "rgba(0, 0, 0, 0.18)",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#555555",
    "--pay-button-bg-disabled": "#E0E0E0",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Input field states
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#FFFFFF",
    "--input-bg-empty": "#FFFFFF",
    "--input-bg-disabled": "#F5F5F5",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#FFFFFF",
    "--input-disabled-bg-variant": "#F5F5F5",
    "--input-focus-blur": "blur(4px)",
    "--loading-skeleton-color": "rgba(0, 0, 0, 0.05)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-border-selected-p": "1px",
    "--card-bg-gradient": "#FFFFFF",
    // Brand-dynamic: accent variables use var(--brand-primary-color)
    "--brand-primary-color": "#000000",
    "--border-gradient": "var(--brand-primary-color)",
    "--input-icon-color": "var(--brand-primary-color)",
    "--input-focus-border": "var(--brand-primary-color)",
    "--input-border-filled": "var(--brand-primary-color)",
    "--input-focus-shadow-bg": "var(--brand-primary-color)",
    "--accent-border": "var(--brand-primary-color)",
    "--button-active-bg": "var(--brand-primary-color)",
    "--button-active-text": "#FFFFFF",
    "--pay-button-bg-enabled": "var(--brand-primary-color)",
    "--pay-button-text-enabled": "#FFFFFF",
    "--upsell-btn-bg-active": "var(--brand-primary-color)",
    "--upsell-border-active": "var(--brand-primary-color)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--badge-success-bg-solid": "var(--brand-primary-color)",
    "--badge-success-bg-gradient": "var(--brand-primary-color)",
    "--badge-quantity-bg": "var(--brand-primary-color)",
    "--badge-text": "#FFFFFF",
    "--badge-quantity-text": "#FFFFFF",
    "--shipping-radio-checked": "var(--brand-primary-color)",
    "--shipping-badge-cheapest": "var(--brand-primary-color)",
    "--shipping-border-selected": "var(--brand-primary-color)"
  }
};
function ha(t) {
  return kt[t] ?? kt[dt];
}
function fa(t) {
  return wt[t] ?? wt[dt];
}
function ya(t) {
  return _n.includes(t);
}
function xa(t) {
  const r = {};
  t.brandColorPrimary && (r["--brand-primary-color"] = t.brandColorPrimary), t.background === "transparent" && (r["--bg"] = "transparent", r["--bg-secondary"] = "rgba(255, 255, 255, 0.7)", r["--card-bg"] = "rgba(255, 255, 255, 0.8)");
  const a = t.buttonTextColor ?? "#FFFFFF";
  r["--button-active-text"] = a, r["--pay-button-text-enabled"] = a, r["--badge-text"] = a, r["--badge-quantity-text"] = a, r["--upsell-btn-text-active"] = a;
  const o = a.replace("#", ""), n = parseInt(o.substring(0, 2), 16), l = parseInt(o.substring(2, 4), 16), c = parseInt(o.substring(4, 6), 16), p = (n * 299 + l * 587 + c * 114) / 1e3;
  return r["--pay-button-icon-filter"] = p < 128 ? "invert(1)" : "none", r;
}
const $t = or({
  themeName: dt
}), ae = () => nr($t), va = ({
  themeName: t,
  children: r
}) => /* @__PURE__ */ e($t.Provider, { value: { themeName: t }, children: r }), An = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-px",
  right: "-px",
  bottom: "-px",
  left: "-px",
  bgImage: "var(--input-focus-border)",
  bgClip: "border-box",
  zIndex: -1
}, je = ({
  variant: t,
  children: r,
  borderRadius: a = "1.125rem",
  borderBottomRadius: o,
  borderTopRadius: n,
  borderTop: l,
  borderBottom: c,
  ...p
}) => {
  const { themeName: s } = ae(), u = s === "glassy";
  return /* @__PURE__ */ e(
    w,
    {
      borderRadius: a,
      borderBottomRadius: o,
      borderTopRadius: n,
      padding: ["gradient", "typing", "error"].includes(t) ? "1px" : "",
      pb: c,
      pt: l,
      width: "100%",
      display: "flex",
      bgImage: ["gradient", "typing"].includes(t) ? "var(--input-focus-border)" : "",
      border: ["primary", "typing", "gradient"].includes(t) ? "1px solid var(--border, #E0E0E0)" : "",
      bg: t === "error" ? "#EE5829" : u ? "rgba(255, 255, 255, 0.85)" : "",
      _before: t === "typing" ? { ...An } : {},
      position: "relative",
      children: /* @__PURE__ */ e(
        w,
        {
          bg: ["gradient", "typing", "error"].includes(t) ? "var(--card-bg, #FFF)" : "transparent",
          borderRadius: a,
          borderBottomRadius: o,
          borderTopRadius: n,
          width: "100%",
          display: "flex",
          children: /* @__PURE__ */ e(
            w,
            {
              bgGradient: t === "gradient" ? "var(--card-bg, #FFF)" : "#FFF",
              borderRadius: a,
              borderBottomRadius: o,
              borderTopRadius: n,
              width: "100%",
              display: "flex",
              ...p,
              children: r
            }
          )
        }
      )
    }
  );
};
je.defaultProps = {
  border: "md",
  variant: "primary"
};
const Sa = ({ title: t, subtitle: r, children: a, hasBorder: o, uppercaseTitle: n, ...l }) => /* @__PURE__ */ d(
  w,
  {
    className: "leaf-card__container",
    w: "full",
    borderWidth: o ? "1px" : "inherit",
    borderRadius: o ? "lg" : "none",
    ...l,
    children: [
      /* @__PURE__ */ d(w, { children: [
        /* @__PURE__ */ e(
          b,
          {
            textTransform: n ? "uppercase" : "none",
            className: "leaf-card__title",
            fontSize: "lg",
            fontWeight: "500",
            lineHeight: "6",
            children: t
          }
        ),
        r ? /* @__PURE__ */ e(
          b,
          {
            className: "leaf-card__subtitle",
            color: "var(--text-muted, #8F8F8F)",
            fontSize: "sm",
            fontWeight: "350",
            lineHeight: "5",
            dangerouslySetInnerHTML: { __html: r }
          }
        ) : null
      ] }),
      a ? /* @__PURE__ */ e(ne, { className: "leaf-card__content", spacing: 2, pt: 4, children: a }) : null
    ]
  }
), Dn = ({
  isOpen: t,
  closedLabel: r,
  title: a,
  openIcon: o,
  drawerPosition: n,
  titleTextProps: l,
  hideCloseIcon: c,
  isFixFooter: p,
  ...s
}) => /* @__PURE__ */ d(
  N,
  {
    "aria-description": "DrawerHeader",
    w: "full",
    position: "absolute",
    cursor: "pointer",
    top: "0",
    zIndex: 1001,
    pt: 1.5,
    px: 4,
    pb: 0,
    justifyContent: "center",
    gap: 2,
    borderTopRadius: "3xl",
    bgColor: "var(--card-bg, #FFF)",
    ...s,
    children: [
      n === "bottom" && /* @__PURE__ */ e(
        w,
        {
          w: "3rem",
          h: "0.25rem",
          bg: "var(--border, #D9D9D9)",
          borderRadius: "0.125rem",
          className: "dash",
          left: "50%",
          transform: "translateX(-50%)",
          position: "absolute"
        }
      ),
      /* @__PURE__ */ e(w, { display: t ? "none" : "flex", mt: 3, children: r }),
      /* @__PURE__ */ d(
        N,
        {
          mt: 2,
          flex: "1",
          alignSelf: "center",
          alignItems: "center",
          alignContent: "center",
          pt: n === "bottom" ? "" : "2",
          justifyContent: n === "bottom" ? "space-between" : "center",
          children: [
            /* @__PURE__ */ e(
              b,
              {
                color: "var(--text, #1C1C1C)",
                textAlign: "center",
                fontWeight: "medium",
                lineHeight: "6",
                fontSize: "md",
                display: t ? "flex" : "none",
                ...l,
                ...n !== "bottom" ? { flex: 1, justifyContent: "center" } : {},
                children: a
              }
            ),
            t && !c && (n === "bottom" && p ? /* @__PURE__ */ e(
              w,
              {
                "aria-description": "justDrawerCloseIcon",
                h: "1.5rem",
                w: "1.5rem",
                rounded: "full",
                bgColor: "var(--bg-secondary, #F7F7F7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ e(
                  "path",
                  {
                    d: "M7.19995 9.60001L12 14.4L16.8 9.60001",
                    stroke: "var(--text-secondary, #585858)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) })
              }
            ) : /* @__PURE__ */ e(
              sr,
              {
                boxSize: "0.8rem",
                "aria-description": "justDrawerCloseIcon",
                top: n === "bottom" ? "4" : "8",
                right: n === "bottom" ? "8" : "12",
                color: "var(--text-secondary, #585858)"
              }
            ))
          ]
        }
      ),
      !t && o ? /* @__PURE__ */ e(w, { mt: 3, children: o }) : null
    ]
  }
), zn = (t, r) => {
  const [a, o] = L(!1);
  return K(() => {
    let n;
    return t && !a ? o(!0) : !t && a && (n = window.setTimeout(() => o(!1), r)), () => {
      clearTimeout(n);
    };
  }, [r, t, a]), a;
};
function Wn() {
  const t = document.createElement("div");
  return t.setAttribute("id", Gt), t;
}
const Gt = "justdrawer-root", Hn = 300, jn = 8, Un = () => {
  const [t, r] = L(!1), a = W(() => {
    r(!t);
  }, [t]), o = W(() => {
    r(!0);
  }, []), n = W(() => {
    r(!1);
  }, []);
  return { isOpen: t, onToggle: a, onClose: n, onOpen: o };
}, fe = (t, r) => t === "bottom" ? `rgba(255, 255, 255, ${r})` : `rgba(0, 0, 0, ${r - 0.3})`, $n = ({
  children: t,
  onClose: r,
  onOpen: a,
  isOpen: o,
  position: n = "bottom",
  title: l,
  removeWhenClosed: c = !0,
  isFullHeight: p = !1,
  size: s = "unset",
  width: u,
  containerRef: i,
  closedLabel: F,
  fixFooter: S,
  onSwipeOpened: m,
  onClickOpened: T,
  onSwipeClosed: f,
  onClickClosed: D,
  openIcon: x,
  titleTextProps: z,
  hideCloseIcon: P,
  lockScrollZones: U = [],
  isMainDrawer: Y,
  closeOnOverlayClick: V = !0,
  closedBgColor: I
}) => {
  const C = re(null), y = re(null), E = re(null), [H, q] = L(fe(n, 0.8)), [J, Z] = L(0), B = te(() => !o && c ? "0" : !o && !F ? "12px" : "46px", [o, c, F]);
  K(() => {
    C.current = document.getElementById(Gt) ?? Wn();
  }, []);
  const _ = zn(o, Hn);
  K(() => {
    (() => {
      i != null && i.current && (o ? i.current.style.overflow = "hidden" : i.current.style.overflow = "");
    })();
  }, [i, o]);
  const j = W(
    (k) => {
      k.key === "Escape" && o && r();
    },
    [o, r]
  ), M = W(() => {
    o ? (r(), D == null || D()) : (a(), T == null || T());
  }, [o, D, T, r, a]), g = W(
    (k) => {
      V && k.target instanceof HTMLElement && k.target.classList.contains("justdrawer-overlay-wrapper") && r();
    },
    [r]
  ), [A, v] = L(0), [h, X] = L({
    start: 0,
    newHeight: 0,
    startHeight: 0,
    swipeUpLocked: !1,
    swipeDownLocked: !1,
    lastActionAborted: !1
  }), Q = W(
    (k) => {
      var pe, ke, ye, we, Ie;
      if (!k.touches[0] || !(E != null && E.current)) return;
      const ee = k.target, Ee = U.some((Re) => !!(ee != null && ee.closest(Re))), Ge = ((pe = E.current) == null ? void 0 : pe.scrollTop) + ((ke = E.current) == null ? void 0 : ke.clientHeight) === ((ye = E.current) == null ? void 0 : ye.scrollHeight), Te = ((we = E.current) == null ? void 0 : we.scrollTop) == 0;
      v(window.innerHeight), X({
        lastActionAborted: !1,
        swipeUpLocked: o && (!Ge || Ee),
        swipeDownLocked: o && (!Te || Ee),
        start: k.touches[0].clientY,
        newHeight: 0,
        startHeight: ((Ie = E == null ? void 0 : E.current) == null ? void 0 : Ie.clientHeight) ?? 0
      });
    },
    [o, U]
  ), oe = W(() => {
    if (h.newHeight !== 0) {
      if (!h.lastActionAborted) {
        const k = jn * (A / 100);
        h.newHeight - h.startHeight > k ? (q(fe(n, 0.8)), Z(1), a(), m == null || m()) : h.startHeight - h.newHeight > k && (q(fe(n, 0)), Z(0), r(), f == null || f());
      }
      X({
        start: 0,
        newHeight: 0,
        startHeight: 0,
        swipeDownLocked: !1,
        swipeUpLocked: !1,
        lastActionAborted: !1
      });
    }
  }, [
    r,
    a,
    f,
    m,
    h.lastActionAborted,
    h.newHeight,
    A
  ]), ie = W(
    (k) => {
      if (!k.touches[0]) return;
      if (h.swipeDownLocked && k.touches[0].clientY - h.start > 0 || h.swipeUpLocked && k.touches[0].clientY - h.start < 0) {
        X({
          ...h,
          lastActionAborted: !0
        });
        return;
      }
      let ee = k.touches[0].clientY - h.start < 0 ? Math.abs(k.touches[0].clientY - h.start) + h.startHeight : h.startHeight - Math.abs(k.touches[0].clientY - h.start);
      return ee = ee < 0 ? 1 : ee, X({
        ...h,
        newHeight: ee
      }), !1;
    },
    [h]
  );
  return K(() => {
    if (h.newHeight) {
      const k = h.newHeight / (A / 2), ee = Math.abs(k < 0.8 ? k : 0.8);
      q(fe(n, ee)), Z(ee);
    } else o ? (q(fe(n, 0.8)), Z(1)) : (q(fe(n, 0)), Z(0));
  }, [h.newHeight, o, A, n]), K(() => (document.addEventListener("keydown", j, !1), () => document.removeEventListener("keydown", j, !1)), [j]), K(() => {
    if (!(i != null && i.current) || !(C != null && C.current)) return;
    i.current.appendChild(C.current);
    const k = i.current;
    return () => {
      k.style.overflow = "";
    };
  }, [i, C]), !_ && c && !o || !C.current ? null : lr(
    /* @__PURE__ */ e(
      "div",
      {
        "aria-hidden": o ? "false" : "true",
        className: `justdrawer-container ${o || h.newHeight ? "open" : ""} ${_ || h.newHeight ? "in" : ""} ${h.newHeight ? "swiping" : ""}`,
        children: /* @__PURE__ */ e(
          w,
          {
            className: "justdrawer-overlay-wrapper",
            backgroundColor: H,
            onClick: (k) => o && g(k),
            children: /* @__PURE__ */ d(
              w,
              {
                onTouchStart: Q,
                onTouchEnd: oe,
                onTouchMove: ie,
                roundedTop: p && n === "bottom" ? "none" : "3xl",
                roundedBottom: n === "bottom" ? "none" : "3xl",
                boxShadow: "0px -2px 12px 0px rgba(0, 0, 0, 0.15)",
                className: `justdrawer ${n}`,
                width: u && o && ["left", "right"].includes(n) ? `${u} !important` : "",
                role: "dialog",
                ref: y,
                pt: B,
                height: !o && !S && n === "bottom" ? 0 : p && o && !h.newHeight ? "full" : "unset",
                zIndex: Y ? "900 !important" : void 0,
                bgColor: o ? "" : I,
                children: [
                  /* @__PURE__ */ e(
                    Dn,
                    {
                      drawerPosition: n,
                      isOpen: o,
                      title: l,
                      closedLabel: F,
                      onClick: M,
                      openIcon: x,
                      titleTextProps: z,
                      hideCloseIcon: P,
                      isFixFooter: !!S,
                      bgColor: o ? "" : I
                    }
                  ),
                  /* @__PURE__ */ e(
                    w,
                    {
                      className: "justdrawer-content",
                      overflowY: "scroll",
                      alignItems: "center",
                      mt: n === "bottom" ? "0" : "7",
                      ref: E,
                      opacity: J,
                      height: h.newHeight ? `${h.newHeight}px` : o ? p ? "full" : s : 0,
                      children: t
                    }
                  ),
                  /* @__PURE__ */ e(w, { px: 4, mt: 2, children: S })
                ]
              }
            )
          }
        )
      }
    ),
    C.current
  );
}, Oe = (t) => t.replace(
  new RegExp("\\p{Emoji}", "gu"),
  ""
).trim();
function Tt(t, r) {
  return t.length > r ? t.slice(0, r) + "..." : t;
}
const ct = (t) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...t,
    children: [
      /* @__PURE__ */ e("path", { d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" }),
      /* @__PURE__ */ e("circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" })
    ]
  }
), Gn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.1'%20cx='16'%20cy='16'%20r='16'%20fill='url(%23paint0_linear_1166_84650)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1166_84650'%20x1='0'%20y1='16'%20x2='32'%20y2='16'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.0208333'%20stop-color='%238DE690'/%3e%3cstop%20offset='0.182292'%20stop-color='%23A5F0A3'/%3e%3cstop%20offset='0.333333'%20stop-color='%23A6ECD7'/%3e%3cstop%20offset='0.515625'%20stop-color='%2397DADA'/%3e%3cstop%20offset='0.677083'%20stop-color='%23B3DAE7'/%3e%3cstop%20offset='0.833333'%20stop-color='%23B6C9EC'/%3e%3cstop%20offset='1'%20stop-color='%23879ACB'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", It = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.3'%20cx='16'%20cy='16'%20r='16'%20fill='%23E0E0E0'/%3e%3c/svg%3e", Tn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.05'%20cx='16'%20cy='16'%20r='16'%20fill='%23EE5829'/%3e%3c/svg%3e", Rt = We(
  ({
    label: t,
    helper: r,
    error: a,
    isInvalid: o,
    isDisabled: n,
    isRequired: l = !0,
    value: c,
    onChange: p,
    onFocus: s,
    onBlur: u,
    Icon: i,
    variantError: F,
    trackingId: S,
    ...m
  }, T) => {
    const [f, D] = L(!1), [x, z] = L(!!a), P = Ke(), { themeName: U } = ae(), Y = U === "black", V = U === "classic", I = U === "custom", C = te(() => {
      const B = P == null ? void 0 : P.themedClasses;
      return {
        inputBorderStyle: (B == null ? void 0 : B.inputBorderStyle) ?? Qe,
        inputBorderGradientStyle: (B == null ? void 0 : B.inputBorderGradientStyle) ?? et,
        inputBorderDisabledStyle: (B == null ? void 0 : B.inputBorderDisabledStyle) ?? ot,
        inputBorderInvalidStyle: (B == null ? void 0 : B.inputBorderInvalidStyle) ?? tt,
        inputBorderEmptyStyle: (B == null ? void 0 : B.inputBorderEmptyStyle) ?? rt,
        inputBackgroundGradientStyle: (B == null ? void 0 : B.inputBackgroundGradientStyle) ?? nt,
        inputBackgroundDisabledStyle: (B == null ? void 0 : B.inputBackgroundDisabledStyle) ?? at,
        inputBackgroundEmptyStyle: (B == null ? void 0 : B.inputBackgroundEmptyStyle) ?? it,
        inputBackgroundInvalidStyle: (B == null ? void 0 : B.inputBackgroundInvalidStyle) ?? lt,
        inputBoxShadowGradientStyle: (B == null ? void 0 : B.inputBoxShadowGradientStyle) ?? st
      };
    }, [P]), y = W(
      (B) => {
        p == null || p(B), z(!1);
      },
      [p, z]
    );
    K(() => {
      z(!!a);
    }, [a, z]);
    const E = {
      bgGradient: "",
      bg: "var(--input-focus-border, #BEBBB4)",
      p: "1px"
    }, H = `var(--input-icon-color, ${Y ? "#FFFFFF" : I ? "#888888" : "#63DD51"})`;
    return /* @__PURE__ */ d(
      Ae,
      {
        variant: "floatingWithIcon",
        isRequired: l,
        isInvalid: !!o,
        isDisabled: !!n,
        width: "full",
        children: [
          /* @__PURE__ */ e(
            w,
            {
              _before: (f && !x || !c && !x && m.type === "email") && !V && !I ? { ...C.inputBoxShadowGradientStyle } : {},
              children: /* @__PURE__ */ e(
                w,
                {
                  ...C.inputBorderStyle,
                  ...C.inputBorderGradientStyle,
                  ...I && E,
                  ...n ? C.inputBorderDisabledStyle : {},
                  ...x || x ? C.inputBorderInvalidStyle : {},
                  ...!c && !f && !x && !I ? C.inputBorderEmptyStyle : {},
                  children: /* @__PURE__ */ d(
                    xe,
                    {
                      alignItems: "center",
                      justifyContent: "space-between",
                      alignContent: "center",
                      alignSelf: "center",
                      children: [
                        /* @__PURE__ */ d(Dt, { boxSize: "2rem", display: "flex", mt: 3, ml: 4, children: [
                          /* @__PURE__ */ e(
                            Je,
                            {
                              src: !x && !n && f || !c && !x && !n && m.type === "email" ? Y ? It : Gn : x && !n ? Tn : It,
                              alt: "Input Ellipse",
                              position: "absolute",
                              top: "0",
                              left: "0",
                              boxSize: "2rem"
                            }
                          ),
                          /* @__PURE__ */ e(
                            i,
                            {
                              fill: c && !x && !n && f || !c && !x && f || !c && !x && !n && m.type === "email" ? H : c && !x && !n ? "var(--text, #1C1C1C)" : x && !n ? "#EE5829" : "#8F8F8F"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ d(xe, { children: [
                          /* @__PURE__ */ e(
                            De,
                            {
                              zIndex: "10",
                              w: "full",
                              variant: "just",
                              placeholder: " ",
                              pl: "3.35rem",
                              pt: 3,
                              fontSize: "md",
                              textAlign: "left",
                              errorBorderColor: "danger.main",
                              ...C.inputBackgroundGradientStyle,
                              ...n ? C.inputBackgroundDisabledStyle : {},
                              ...x ? C.inputBackgroundInvalidStyle : {},
                              ...c ? {} : C.inputBackgroundEmptyStyle,
                              borderColor: "transparent",
                              pr: 12,
                              sx: {
                                "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active": {
                                  WebkitBoxShadow: "0 0 0 30px var(--input-bg, #FFF) inset !important",
                                  boxShadow: "0 0 0 30px var(--input-bg, #FFF) inset !important",
                                  WebkitTextFillColor: "var(--text, #1C1C1C) !important",
                                  caretColor: "var(--text, #1C1C1C)",
                                  transition: "background-color 99999s ease-out 0s, color 99999s ease-out 0s"
                                }
                              },
                              value: c,
                              onChange: y,
                              onError: () => {
                                z(!0);
                              },
                              onFocus: (B) => {
                                D(!0), s == null || s(B);
                              },
                              onBlur: (B) => {
                                D(!1), u == null || u(B);
                              },
                              ref: T,
                              ...m,
                              _disabled: { cursor: "default" },
                              "data-ph-capture-attribute-tracking-id": S
                            }
                          ),
                          t && /* @__PURE__ */ e(
                            Ze,
                            {
                              requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                              fontSize: "md",
                              ml: "3.5",
                              px: "2px",
                              bg: "transparent",
                              style: {
                                backgroundColor: "transparent",
                                zIndex: "20"
                              },
                              children: t
                            }
                          )
                        ] })
                      ]
                    }
                  )
                }
              )
            }
          ),
          r && /* @__PURE__ */ e(zt, { pl: "4", fontSize: "xs", children: r }),
          x && /* @__PURE__ */ e(
            ze,
            {
              fontSize: "0.75rem",
              fontWeight: "350",
              zIndex: "5",
              w: "fit-content",
              borderRadius: "0.25rem",
              sx: F === "discount" ? {
                position: "relative",
                color: "#FFF",
                bg: "danger.main",
                borderRadius: "1.875rem",
                py: "0.375rem",
                px: "0.75rem",
                alignItems: "center",
                gap: "1"
              } : {
                position: "absolute",
                color: "danger.main",
                bg: "var(--input-bg-error-message, #FFF)",
                bottom: "-2",
                right: "5",
                px: "1",
                mb: "0.5"
              },
              children: a
            }
          )
        ]
      }
    );
  }
), Ca = ({ name: t, control: r, onChange: a, onBlur: o, ...n }) => /* @__PURE__ */ e(
  Ht,
  {
    control: r,
    name: t,
    render: ({ field: l }) => /* @__PURE__ */ e(
      Rt,
      {
        ...n,
        ...l,
        value: l.value ?? "",
        onChange: (c) => {
          l.onChange(c), a == null || a(c);
        },
        onBlur: () => {
          l.onBlur(), o == null || o();
        }
      }
    )
  }
), Rn = "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)", Ue = {
  gradient: Rn,
  text: "#1C1C1C",
  icon: "#1C1C1C",
  useBgProp: !1,
  appliedTextColor: "#1C1C1C",
  useCustomButtonStyle: !1
}, Le = {
  gradient: "var(--accent-border, #000000)",
  text: "#FFFFFF",
  icon: "#FFFFFF",
  useBgProp: !0,
  appliedTextColor: "#FFFFFF",
  useCustomButtonStyle: !0
}, $e = {
  black: {
    gradient: "linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.15) 100%)",
    text: "#FFFFFF",
    icon: "#FFFFFF",
    useBgProp: !0,
    appliedTextColor: "#1C1C1C",
    useCustomButtonStyle: !1
  },
  soft: Le,
  classic: Le,
  custom: Le
}, Ln = ({
  discount: t,
  onDiscountRemove: r,
  currency: a
}) => {
  var s;
  const [o, n] = L(!1), { themeName: l } = ae(), c = $e[l] ?? Ue, p = W(async () => {
    t.code && (n(!0), await r(t.code), n(!1));
  }, []);
  return /* @__PURE__ */ d(N, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ d(
      O,
      {
        ...c.useBgProp ? { bg: c.gradient } : { bgGradient: c.gradient },
        opacity: o ? 0.5 : 1,
        borderRadius: "base",
        spacing: 1,
        display: "flex",
        pt: 1.5,
        pr: 1.5,
        pb: 1.5,
        pl: 3,
        alignItems: "center",
        gap: 1,
        children: [
          /* @__PURE__ */ e(ct, { width: "12px", height: "12px", "aria-hidden": "true", focusable: "false", stroke: c.icon }),
          /* @__PURE__ */ e(b, { color: c.text, fontSize: "sm", fontWeight: "medium", lineHeight: "5", children: Tt(((s = t.code) == null ? void 0 : s.toUpperCase()) ?? "", 24) }),
          /* @__PURE__ */ d(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: 20,
              height: 20,
              fill: "none",
              onClick: p,
              cursor: "pointer",
              "data-ph-capture-attribute-tracking-id": "discount-remove-button",
              children: [
                /* @__PURE__ */ e("title", { children: "Remove" }),
                /* @__PURE__ */ e("g", { stroke: c.icon, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, children: /* @__PURE__ */ e("path", { d: "M15 5 5 15M5 5l10 10" }) })
              ]
            }
          )
        ]
      }
    ),
    !!t.amount && /* @__PURE__ */ e(b, { fontSize: "sm", color: "var(--text-secondary, #585858)", fontWeight: "normal", children: ve(t.amount, { currency: a }) }),
    t.title && ((t == null ? void 0 : t.target) !== "SHIPPING_LINE" || !t.target) && /* @__PURE__ */ d(b, { lineHeight: "5", color: "var(--text-secondary, #585858)", textAlign: "right", fontSize: "sm", children: [
      "−",
      t.title
    ] })
  ] });
}, Mn = ({
  giftCard: t,
  onGiftCardRemove: r
}) => {
  var p;
  const [a, o] = L(!1), { themeName: n } = ae(), l = $e[n] ?? Ue, c = W(async () => {
    t.code && (o(!0), await r(), o(!1));
  }, [o, r, t]);
  return /* @__PURE__ */ e(N, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ d(
    O,
    {
      ...l.useBgProp ? { bg: l.gradient } : { bgGradient: l.gradient },
      opacity: a ? 0.5 : 1,
      borderRadius: "base",
      spacing: 1,
      display: "flex",
      pt: 1.5,
      pr: 1.5,
      pb: 1.5,
      pl: 3,
      alignItems: "center",
      gap: 1,
      children: [
        /* @__PURE__ */ e(ct, { width: "12px", height: "12px", "aria-hidden": "true", focusable: "false", stroke: l.icon }),
        /* @__PURE__ */ e(b, { color: l.text, fontSize: "sm", fontWeight: "medium", lineHeight: "5", children: Tt(((p = t.code) == null ? void 0 : p.toUpperCase()) ?? "", 24) }),
        /* @__PURE__ */ d(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: 20,
            height: 20,
            fill: "none",
            onClick: c,
            cursor: "pointer",
            children: [
              /* @__PURE__ */ e("title", { children: "Remove" }),
              /* @__PURE__ */ e("g", { stroke: l.icon, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, children: /* @__PURE__ */ e("path", { d: "M15 5 5 15M5 5l10 10" }) })
            ]
          }
        )
      ]
    }
  ) });
}, Pn = ({
  discountCode: t,
  onDiscountRemove: r,
  onDiscountAddClick: a,
  appliedDiscounts: o,
  currency: n,
  discountApplyLabel: l
}) => {
  const [c, p] = L(!1), { themeName: s } = ae(), u = $e[s] ?? Ue, i = o.find((m) => (m == null ? void 0 : m.code) == t), F = W(async () => {
    p(!0);
    try {
      i != null && i.code ? await r(i == null ? void 0 : i.code) : await a(t, !0);
    } catch {
    }
    p(!1);
  }, [i]), S = i ? u.appliedTextColor : "var(--text, #1C1C1C)";
  return /* @__PURE__ */ d(N, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ d(
      O,
      {
        onClick: F,
        bgImage: i ? "var(--border-gradient, none)" : "",
        bg: i ? "var(--accent-border, #F6BCFF)" : "",
        borderWidth: i ? "" : "2px",
        borderStyle: i ? "" : "dashed",
        borderColor: i ? "" : "var(--accent-border, #F6BCFF)",
        cursor: "pointer",
        opacity: c ? 0.5 : 1,
        borderRadius: "base",
        spacing: 1,
        display: "flex",
        pt: 1.5,
        pr: i ? 1.5 : 3,
        pb: 1.5,
        pl: 3,
        alignItems: "center",
        gap: 1,
        "data-ph-capture-attribute-tracking-id": "recommended-discount-item",
        color: S,
        children: [
          /* @__PURE__ */ e(ct, { width: "12px", height: "12px", "aria-hidden": "true", focusable: "false" }),
          /* @__PURE__ */ e(
            b,
            {
              color: S,
              fontSize: "sm",
              fontWeight: "medium",
              lineHeight: "5",
              children: t == null ? void 0 : t.toUpperCase()
            }
          ),
          i ? /* @__PURE__ */ d(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: 20,
              height: 20,
              fill: "none",
              onClick: F,
              cursor: "pointer",
              children: [
                /* @__PURE__ */ e("title", { children: "Remove" }),
                /* @__PURE__ */ e(
                  "g",
                  {
                    stroke: S,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.5,
                    children: /* @__PURE__ */ e("path", { d: "M15 5 5 15M5 5l10 10" })
                  }
                )
              ]
            }
          ) : null
        ]
      }
    ),
    i != null && i.amount ? /* @__PURE__ */ e(b, { fontSize: "sm", color: "var(--text-secondary, #585858)", fontWeight: "normal", children: ve(i == null ? void 0 : i.amount, { currency: n }) }) : null,
    (i == null ? void 0 : i.title) && ((i == null ? void 0 : i.target) !== "SHIPPING_LINE" || !i.target) && /* @__PURE__ */ d(b, { lineHeight: "5", color: "var(--text-secondary, #585858)", textAlign: "right", fontSize: "sm", children: [
      "−",
      i == null ? void 0 : i.title
    ] }),
    i ? null : /* @__PURE__ */ e(
      He,
      {
        trackingId: "recommended-discount-item-apply-button",
        size: "xs",
        type: "submit",
        isLoading: c,
        width: "auto",
        h: "8",
        label: l,
        display: "flex",
        py: 4,
        px: 6,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: 2,
        ml: 1.5,
        onClick: F,
        sx: {
          ...u.useCustomButtonStyle ? {
            background: "var(--button-active-bg)",
            color: "var(--button-active-text)"
          } : {},
          "&:hover, &:disabled": {
            bgImage: "none",
            border: "1px solid var(--border, #E0E0E0)",
            background: "var(--bg-secondary, #F7F7F7)",
            color: "var(--text, #1C1C1C)"
          },
          "&:disable": {
            cursor: "default"
          },
          border: "1px solid transparent",
          fontWeight: "medium",
          lineHeight: "6",
          fontSize: "md"
        }
      }
    )
  ] });
}, _t = ({
  discountApplyLabel: t,
  discountInputLabel: r,
  isDiscountDisabled: a = !1,
  isDiscountHidden: o = !1,
  onDiscountAddClick: n,
  discountErrorLabel: l,
  onDiscountRemove: c,
  onGiftCardRemove: p,
  discounts: s,
  giftCards: u,
  currency: i,
  shouldFocusField: F,
  discountFinderLabel: S,
  recommendedDiscountCodes: m = [],
  Icon: T,
  setDiscountValue: f
}) => {
  var y;
  const [D, x] = L(""), z = re(null), [P, U] = L(!1), { themeName: Y } = ae(), V = $e[Y] ?? Ue, I = W(async () => {
    f == null || f(z.current.value), U(!0);
    try {
      await n(z.current.value), x(""), f == null || f("");
    } finally {
      U(!1);
    }
  }, [U, n, z]), C = W(
    (E) => {
      E.key === "Enter" && I();
    },
    [I]
  );
  return K(() => {
    var E;
    F && ((E = z.current) == null || E.focus());
  }, [F]), /* @__PURE__ */ d(le, { children: [
    o === !0 ? null : /* @__PURE__ */ d(
      xe,
      {
        size: "md",
        display: "flex",
        flexDirection: "row",
        alignItems: "flexStart",
        justifyContent: "center",
        children: [
          /* @__PURE__ */ e(
            Rt,
            {
              trackingId: "discount-input",
              autoComplete: "text",
              ref: z,
              isInvalid: !!l,
              isDisabled: a,
              label: r,
              isRequired: !1,
              flex: "1 0 0",
              h: "14",
              value: D,
              variantError: "discount",
              onChange: (E) => {
                x(E.currentTarget.value);
              },
              gap: 4,
              Icon: T,
              onKeyDown: C
            }
          ),
          /* @__PURE__ */ e(
            He,
            {
              size: "sm",
              type: "submit",
              isLoading: P,
              isDisabled: ((y = D == null ? void 0 : D.trim()) == null ? void 0 : y.length) === 0,
              width: "auto",
              h: "14",
              label: t,
              display: "flex",
              py: 4,
              px: 6,
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              gap: 2,
              ml: 1.5,
              onClick: I,
              sx: {
                ...V.useCustomButtonStyle ? {
                  background: "var(--button-active-bg)",
                  color: "var(--button-active-text)"
                } : {},
                "&:hover, &:disabled": {
                  bgImage: "none",
                  border: "1px solid var(--border, #E0E0E0)",
                  background: "var(--bg-secondary, #F7F7F7)",
                  color: "var(--text, #1C1C1C)"
                },
                "&:disable": {
                  cursor: "default"
                },
                border: "1px solid transparent",
                fontWeight: "medium",
                lineHeight: "6",
                fontSize: "md"
              },
              trackingId: "discount-apply-button"
            }
          )
        ]
      }
    ),
    l && /* @__PURE__ */ e(
      b,
      {
        fontSize: "0.75rem",
        fontWeight: "350",
        zIndex: "5",
        w: "full",
        sx: {
          position: "relative",
          color: "#FFF",
          bg: "danger.main",
          borderRadius: "1.875rem",
          py: "0.375rem",
          px: "0.75rem",
          alignItems: "center",
          gap: "1"
        },
        children: l
      }
    ),
    /* @__PURE__ */ d(ne, { pt: 2, children: [
      u != null && u.length ? u.map((E) => /* @__PURE__ */ e(
        Mn,
        {
          giftCard: E,
          onGiftCardRemove: p,
          currency: i
        },
        E.id || E.code
      )) : null,
      s != null && s.length ? s.filter((E) => !m.some(
        (H) => E.code == H
      )).filter((E) => {
        var H, q, J;
        return !((J = (q = (H = E.code) == null ? void 0 : H.toLowerCase) == null ? void 0 : q.call(H)) != null && J.includes(" discount "));
      }).map((E) => /* @__PURE__ */ e(
        Ln,
        {
          discount: E,
          onDiscountRemove: c,
          currency: i
        },
        E.id || E.code
      )) : null
    ] }),
    m != null && m.length ? /* @__PURE__ */ d(le, { children: [
      /* @__PURE__ */ e(ne, { children: /* @__PURE__ */ e(b, { className: "leaf-card__title", fontSize: "md", fontWeight: "500", lineHeight: "6", children: S }) }),
      /* @__PURE__ */ e(ne, { pt: 2, children: m != null && m.length ? m.map((E) => /* @__PURE__ */ e(
        Pn,
        {
          appliedDiscounts: s ?? [],
          discountApplyLabel: t,
          discountCode: E,
          onDiscountRemove: c,
          onDiscountAddClick: n,
          currency: i
        },
        E
      )) : null })
    ] }) : null
  ] });
}, Lt = ({ boxSize: t = "4.5rem", borderRadius: r = "md", background: a, ...o }) => {
  const [n, l] = L(!0);
  return /* @__PURE__ */ d(w, { boxSize: t, borderRadius: r, background: a, flexShrink: 0, children: [
    /* @__PURE__ */ e(
      Pe,
      {
        width: "full",
        height: "full",
        borderRadius: r,
        display: n ? "block" : "none",
        visibility: n ? "visible" : "hidden"
      }
    ),
    /* @__PURE__ */ e(
      Je,
      {
        ...o,
        w: "full",
        h: "full",
        loading: "lazy",
        borderRadius: r,
        opacity: n ? 0 : 1,
        onLoad: () => l(!1),
        transition: "opacity 0.3s ease-in-out",
        visibility: n ? "hidden" : "visible"
      }
    )
  ] });
}, Nn = (t) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...t,
    children: [
      /* @__PURE__ */ e("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }),
      /* @__PURE__ */ e("path", { d: "M3 6h18" }),
      /* @__PURE__ */ e("path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
    ]
  }
), Yn = 0, qn = 99, Vn = ({
  id: t,
  productId: r,
  variantId: a,
  defaultQuantity: o,
  minProductQuantity: n = Yn,
  maxProductQuantity: l = qn,
  customizationId: c,
  updateQuantity: p,
  isDisabled: s = !1,
  isLoading: u = !1
}) => {
  const [i, F] = L(o);
  K(() => {
    F(o);
  }, [o]);
  const S = W(
    async (m) => {
      if (l < 0 || i < l || i > n) {
        F(m);
        try {
          const T = await p({
            newQuantity: m,
            id: t,
            productId: r,
            variantId: a,
            customizationId: c
          });
          T !== m && F(T);
        } catch {
          F(o);
        }
      }
    },
    [
      c,
      o,
      t,
      l,
      n,
      r,
      i,
      p,
      a
    ]
  );
  return /* @__PURE__ */ d(
    O,
    {
      width: "5.625rem",
      height: "1.75rem",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "24px",
      border: "1px solid",
      borderColor: "var(--border, #E0E0E0)",
      background: "var(--card-bg, #FFF)",
      boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.06)",
      gap: 0,
      children: [
        /* @__PURE__ */ e(
          de,
          {
            "data-ph-capture-attribute-tracking-id": i === 1 ? "quantity-selector-delete-button" : "quantity-selector-decrement-button",
            onClick: () => S(i - 1),
            variant: "ghost",
            h: "full",
            color: "gray.603",
            paddingInlineStart: 2,
            paddingInlineEnd: 2,
            minW: 8,
            flexShrink: 0,
            roundedRight: "none",
            isDisabled: s || i <= n,
            children: i === 1 ? /* @__PURE__ */ e(Nn, { width: 16, height: 16, color: "var(--text-muted, #8F8F8F)" }) : "-"
          }
        ),
        /* @__PURE__ */ e(
          b,
          {
            color: "gray.603",
            textAlign: "center",
            fontSize: "sm",
            lineHeight: "shorter",
            flex: "1",
            minW: 0,
            overflow: "hidden",
            opacity: u ? 0.7 : 1,
            transition: "opacity 0.45s ease",
            children: i
          }
        ),
        /* @__PURE__ */ e(
          de,
          {
            "data-ph-capture-attribute-tracking-id": "quantity-selector-increment-button",
            onClick: () => S(i + 1),
            variant: "ghost",
            h: "full",
            minW: 8,
            color: "gray.603",
            paddingInlineStart: 2,
            paddingInlineEnd: 2,
            flexShrink: 0,
            roundedLeft: "none",
            isDisabled: s || i >= l && l >= 0,
            children: "+"
          }
        )
      ]
    }
  );
}, At = ({
  customAttributes: t,
  customizationId: r,
  discountAmount: a,
  id: o,
  imageUrl: n,
  name: l,
  productId: c,
  quantity: p,
  quantityAvailable: s,
  variant: u,
  variantId: i = void 0,
  isAvailable: F,
  isQuantityDisabled: S,
  isStockDisabled: m,
  isQuantityUpdateDisabled: T = !1,
  currency: f,
  updateQuantity: D,
  originalAmount: x,
  leftQuantityTitle: z,
  unavailableMessage: P,
  onlyOneLineItemInCart: U = !1,
  isMobile: Y,
  unitAmount: V,
  totalAmount: I,
  isLoading: C = !1,
  isCartBusy: y = !1
}) => {
  const E = te(() => 6.12 * l.length > 175 ? "xs" : "md", [l]), H = te(
    () => ({
      // Match the surrounding surface so the badge looks “cut out” regardless of theme.
      badgeBorderColor: "var(--badge-border-bg, #E0E0E0)",
      badgeBg: "var(--badge-quantity-bg, linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%))",
      badgeTextColor: "var(--badge-quantity-text, #1C1C1C)",
      textColor: "var(--text-secondary, #585858)",
      mutedTextColor: "var(--text-muted, #8F8F8F)",
      dangerTextColor: "var(--danger-text, #C74931)"
    }),
    []
  ), q = x && x !== 0 && x !== V, J = q ? ut(x).multiply(p).value : I, Z = a ? ut(I).subtract(Math.abs(a)).value : I, _ = Z !== I || q, j = te(() => {
    const g = u == null ? void 0 : u.reduce((h, X) => h += X, "");
    return ((g == null ? void 0 : g.length) ?? 0) <= 35;
  }, [u]), M = te(() => {
    const g = new RegExp(
      /https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
    );
    return (t == null ? void 0 : t.map(({ key: A, value: v }) => {
      let h = v ?? "";
      return h.match(g) && (h = "Uploaded"), {
        key: A,
        value: h
      };
    })) ?? [];
  }, [t]);
  return /* @__PURE__ */ d(
    O,
    {
      justifyContent: "space-between",
      alignItems: "center",
      opacity: F ? 1 : 0.4,
      w: "full",
      position: "relative",
      children: [
        /* @__PURE__ */ e(
          Yt,
          {
            position: "absolute",
            top: "-0.5rem",
            left: "0",
            ml: "4rem",
            width: "1.3rem",
            height: "1.3rem",
            borderRadius: "full",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid",
            zIndex: 10,
            borderColor: H.badgeBorderColor,
            bg: H.badgeBg,
            children: /* @__PURE__ */ e(
              b,
              {
                "aria-description": "badgeProductQuantity",
                color: H.badgeTextColor,
                textAlign: "center",
                fontFamily: "IBM Plex Mono",
                fontSize: "0.6875rem",
                fontStyle: "normal",
                fontWeight: "bold",
                lineHeight: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                w: "full",
                h: "full",
                opacity: C ? 0.7 : 1,
                transition: "opacity 0.15s ease",
                children: p
              }
            )
          }
        ),
        /* @__PURE__ */ d(
          N,
          {
            pb: 1,
            px: 0,
            "justify-content": "space-between",
            "align-items": "flex-start",
            gap: 4,
            flexShrink: "0",
            width: "full",
            children: [
              /* @__PURE__ */ e(
                Lt,
                {
                  boxSize: "4.5rem",
                  borderRadius: "md",
                  src: n,
                  alt: l,
                  flexShrink: "0",
                  objectFit: "cover",
                  background: "lightgray 50% / cover no-repeat"
                }
              ),
              /* @__PURE__ */ d(ce, { align: "start", spacing: 0.5, whiteSpace: "break-spaces", children: [
                /* @__PURE__ */ e(
                  b,
                  {
                    fontWeight: "medium",
                    fontSize: Y ? E : "sm",
                    lineHeight: "4",
                    color: H.textColor,
                    "aria-description": "productName",
                    children: l
                  }
                ),
                /* @__PURE__ */ d(O, { flex: 1, flexWrap: "wrap", w: "full", "aria-description": "variantNames", children: [
                  u != null && u.length ? u.map((g, A) => /* @__PURE__ */ d(O, { spacing: 1, children: [
                    /* @__PURE__ */ e(
                      b,
                      {
                        color: H.textColor,
                        textAlign: "left",
                        fontSize: "0.8125rem",
                        fontWeight: "350",
                        lineHeight: "4",
                        children: g
                      }
                    ),
                    A < u.length - 1 && /* @__PURE__ */ e(se, { orientation: "vertical", h: "2", color: H.textColor })
                  ] }, g)) : null,
                  !m && s !== void 0 && s >= 0 && s < 11 && /* @__PURE__ */ d(O, { spacing: 2, children: [
                    (u == null ? void 0 : u.length) && j && /* @__PURE__ */ e(se, { orientation: "vertical", h: "2", color: H.textColor }),
                    /* @__PURE__ */ e(
                      b,
                      {
                        color: "danger.main",
                        textAlign: "center",
                        fontSize: "0.8125rem",
                        fontWeight: "350",
                        lineHeight: "4",
                        children: z
                      }
                    )
                  ] })
                ] }),
                P && /* @__PURE__ */ e(
                  b,
                  {
                    color: "danger.main",
                    fontSize: "0.8125rem",
                    fontWeight: "350",
                    lineHeight: "4",
                    "aria-description": "unavailableMessage",
                    children: P
                  }
                ),
                M != null && M.length ? M == null ? void 0 : M.map((g) => /* @__PURE__ */ d(
                  b,
                  {
                    fontWeight: "normal",
                    color: H.mutedTextColor,
                    fontSize: "0.8125rem",
                    lineHeight: "4",
                    w: "full",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    style: {
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical"
                    },
                    children: [
                      g.key,
                      " - ",
                      g.value
                    ]
                  },
                  g.key
                )) : null,
                /* @__PURE__ */ d(O, { flex: 1, spacing: 1, mb: 3, h: "1.5rem", alignItems: "center", children: [
                  /* @__PURE__ */ e(
                    b,
                    {
                      lineHeight: "4",
                      color: H.mutedTextColor,
                      textDecorationLine: _ ? "line-through" : "",
                      "aria-description": "originalProductAmount",
                      opacity: C ? 0.7 : 1,
                      transition: "opacity 0.15s ease",
                      children: ve(J, {
                        currency: f ?? "EUR"
                      })
                    }
                  ),
                  _ && /* @__PURE__ */ e(
                    b,
                    {
                      color: H.dangerTextColor,
                      lineHeight: "4",
                      "aria-description": "discountedProductAmount",
                      opacity: C ? 0.7 : 1,
                      transition: "opacity 0.15s ease",
                      children: ve(Z, { currency: f ?? "EUR" })
                    }
                  )
                ] }),
                !S && /* @__PURE__ */ e(
                  Vn,
                  {
                    id: o,
                    variantId: i,
                    defaultQuantity: p,
                    customizationId: r,
                    productId: c,
                    updateQuantity: D,
                    maxProductQuantity: s,
                    isDisabled: T || C || y,
                    isLoading: C,
                    minProductQuantity: U ? 1 : 0
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, Xn = ({ showQuantity: t = !0, loadingColor: r }) => /* @__PURE__ */ d(O, { spacing: 4, align: "start", w: "full", pb: 1, children: [
  /* @__PURE__ */ e(
    Pe,
    {
      width: "4.5rem",
      height: "4.5rem",
      borderRadius: "md",
      flexShrink: 0,
      startColor: r,
      endColor: "var(--border, #E0E0E0)"
    }
  ),
  /* @__PURE__ */ e(w, { flex: "1", py: "0.125rem", children: /* @__PURE__ */ e(
    Pe,
    {
      height: t ? "4.25rem" : "2.5rem",
      width: "100%",
      borderRadius: "md",
      startColor: r,
      endColor: "var(--border, #E0E0E0)"
    }
  ) })
] }), On = ({
  totalDiscount: t,
  subTotal: r,
  shipping: a,
  tax: o,
  giftWrapping: n,
  totalGiftCard: l,
  totalDuties: c,
  totalSale: p,
  isMobile: s,
  isLoading: u
}) => {
  const i = u ? 0.7 : 1, F = "opacity 0.15s ease";
  return /* @__PURE__ */ d(w, { fontSize: s ? "md" : "sm", children: [
    /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "subtotalDiv",
        children: [
          /* @__PURE__ */ e(b, { fontWeight: "normal", lineHeight: "6", color: "var(--text-muted, #8F8F8F)", children: r.label }),
          /* @__PURE__ */ e(
            b,
            {
              lineHeight: "6",
              color: "var(--text-muted, #8F8F8F)",
              opacity: i,
              transition: F,
              children: r.value
            }
          )
        ]
      }
    ),
    (a == null ? void 0 : a.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "shippingDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "var(--text-muted, #8F8F8F)", children: a.label }),
          /* @__PURE__ */ e(
            b,
            {
              lineHeight: "6",
              color: "var(--text-muted, #8F8F8F)",
              opacity: i,
              transition: F,
              children: a.value
            }
          )
        ]
      }
    ),
    (p == null ? void 0 : p.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "totalSaleDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "#C74931", children: p.label }),
          /* @__PURE__ */ d(b, { lineHeight: "6", color: "#C74931", opacity: i, transition: F, children: [
            "-",
            p.value
          ] })
        ]
      }
    ),
    (t == null ? void 0 : t.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "totalDiscountDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "#C74931", children: t.label }),
          /* @__PURE__ */ d(b, { lineHeight: "6", color: "#C74931", opacity: i, transition: F, children: [
            "-",
            t.value
          ] })
        ]
      }
    ),
    (n == null ? void 0 : n.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "giftWrappingDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "var(--text-muted, #8F8F8F)", children: n.label ?? "" }),
          /* @__PURE__ */ d(
            b,
            {
              lineHeight: "6",
              color: "var(--text-muted, #8F8F8F)",
              opacity: i,
              transition: F,
              children: [
                "-",
                n.value
              ]
            }
          )
        ]
      }
    ),
    (o == null ? void 0 : o.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "taxDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "var(--text-muted, #8F8F8F)", children: o.label }),
          /* @__PURE__ */ e(
            b,
            {
              lineHeight: "6",
              color: "var(--text-muted, #8F8F8F)",
              opacity: i,
              transition: F,
              children: o.value
            }
          )
        ]
      }
    ),
    (c == null ? void 0 : c.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "totalDutiesDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "var(--text-muted, #8F8F8F)", children: c.label }),
          /* @__PURE__ */ e(
            b,
            {
              lineHeight: "6",
              color: "var(--text-muted, #8F8F8F)",
              opacity: i,
              transition: F,
              children: c.value
            }
          )
        ]
      }
    ),
    (l == null ? void 0 : l.value) && /* @__PURE__ */ d(
      N,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: s ? "1" : "",
        "aria-description": "totalDiscountDiv",
        children: [
          /* @__PURE__ */ e(b, { lineHeight: "6", color: "#C74931", children: l.label }),
          /* @__PURE__ */ d(b, { lineHeight: "6", color: "#C74931", opacity: i, transition: F, children: [
            "-",
            l.value
          ] })
        ]
      }
    )
  ] });
}, Kn = ({ label: t, value: r, taxIncludedTitle: a, isMobile: o, flexOrder: n, isLoading: l }) => /* @__PURE__ */ d(w, { order: n, children: [
  /* @__PURE__ */ d(N, { justifyContent: "space-between", alignItems: "center", "aria-description": "totalDiv", children: [
    /* @__PURE__ */ e(
      b,
      {
        color: "var(--text, #1C1C1C)",
        fontSize: o ? "lg" : "md",
        fontWeight: "semibold",
        lineHeight: "6",
        children: t
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        color: "var(--text, #1C1C1C)",
        fontSize: o ? "lg" : "md",
        fontWeight: "semibold",
        lineHeight: "6",
        opacity: l ? 0.7 : 1,
        transition: "opacity 0.15s ease",
        children: r
      }
    )
  ] }),
  a && /* @__PURE__ */ e(N, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ e(b, { color: "var(--text-muted, #8F8F8F)", fontSize: "0.625rem", children: `(${a})` }) })
] }), Ba = ({
  showEmailOnly: t = !1,
  discountCodeQuestion: r,
  addDiscountLabel: a,
  discountCodeDrawerTitle: o,
  products: n,
  currency: l,
  totalDiscount: c,
  totalDuties: p,
  totalSale: s,
  giftWrapping: u,
  subTotal: i,
  shipping: F,
  total: S,
  tax: m,
  discountApplyLabel: T,
  discountFinderLabel: f,
  discountInputLabel: D,
  totalGiftCard: x,
  isDiscountDisabled: z,
  isDiscountHidden: P,
  isQuantityDisabled: U,
  isStockDisabled: Y = !1,
  onDiscountAddClick: V,
  onDiscountRemove: I,
  onGiftCardRemove: C,
  discountErrorLabel: y,
  discounts: E,
  giftCards: H,
  shouldFocusDiscountField: q,
  updateQuantity: J,
  taxIncludedTitle: Z,
  leftQuantityTitles: B,
  Icon: _,
  availabilityMessage: j,
  outOfStockMessage: M = "",
  notFulfillableMessage: g = "",
  updatedCartInformation: A,
  corrections: v,
  isMobile: h,
  setDiscountValue: X,
  recommendedDiscountCodes: Q,
  renderBeforeDiscounts: oe,
  isItemLoading: ie,
  isAnyItemLoading: k,
  renderAfterProducts: ee,
  pendingProducts: Ee,
  ...Ge
}) => {
  const { isOpen: Te, onOpen: pe, onClose: ke } = Un(), { themeName: ye } = ae(), we = ye === "soft" || ye === "classic", Ie = new Set(n.map(($) => $.productId)), Re = new Set(
    (v ?? []).filter(($) => $.reason === "notFulfillable").map(($) => $.productId)
  );
  return /* @__PURE__ */ d(ne, { ...Ge, w: "full", children: [
    /* @__PURE__ */ e(ne, { order: t ? 3 : void 0, w: "full", py: "0", children: /* @__PURE__ */ e(
      On,
      {
        giftWrapping: u,
        tax: m,
        totalGiftCard: x,
        totalDiscount: c,
        totalDuties: p,
        subTotal: i,
        shipping: F,
        isMobile: h,
        totalSale: s,
        isLoading: k
      }
    ) }),
    /* @__PURE__ */ e(
      Kn,
      {
        flexOrder: t ? 4 : void 0,
        value: S.value,
        label: S.label,
        isMobile: h,
        taxIncludedTitle: Z,
        isLoading: k
      }
    ),
    oe,
    t ? /* @__PURE__ */ d(ce, { order: 5, children: [
      /* @__PURE__ */ e(se, { mt: "2" }),
      /* @__PURE__ */ d(O, { mt: "1.5", justify: "space-between", align: "center", w: "full", onClick: pe, children: [
        /* @__PURE__ */ e(b, { fontSize: "md", color: "var(--text-secondary)", children: r }),
        /* @__PURE__ */ e(de, { onClick: pe, "data-ph-capture-attribute-tracking-id": "discount-code-add-button", children: a })
      ] })
    ] }) : /* @__PURE__ */ e(
      _t,
      {
        discountApplyLabel: T,
        discountFinderLabel: f,
        discountInputLabel: D,
        discountErrorLabel: y,
        recommendedDiscountCodes: Q,
        discounts: E,
        giftCards: H,
        onDiscountAddClick: V,
        onDiscountRemove: I,
        onGiftCardRemove: C,
        isDiscountDisabled: !!z,
        isDiscountHidden: !!P,
        shouldFocusField: !!q,
        currency: l,
        Icon: _,
        setDiscountValue: X
      }
    ),
    /* @__PURE__ */ e(
      se,
      {
        order: t ? 2 : void 0,
        variant: we ? "solid" : "dashed",
        py: "0",
        my: t ? "6" : "0"
      }
    ),
    A && /* @__PURE__ */ e(b, { order: t ? 6 : void 0, color: "danger.main", fontSize: "md", children: A }),
    j && /* @__PURE__ */ e(b, { order: t ? 7 : void 0, color: "danger.main", fontSize: "sm", children: j }),
    /* @__PURE__ */ d(
      ce,
      {
        order: t ? 1 : void 0,
        gap: 0,
        align: "start",
        className: "cart__product-list",
        pt: "2",
        children: [
          /* @__PURE__ */ d(ir, { initial: !1, mode: "sync", children: [
            Array.from({ length: Ee ?? 0 }, ($, be) => /* @__PURE__ */ e(
              gt.div,
              {
                initial: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0 },
                animate: {
                  opacity: 1,
                  height: "auto",
                  paddingTop: "0.5rem",
                  marginBottom: "0.75rem"
                },
                exit: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0, transition: { duration: 0 } },
                transition: {
                  height: { duration: 0.3, ease: "easeInOut" },
                  paddingTop: { duration: 0.3, ease: "easeInOut" },
                  marginBottom: { duration: 0.3, ease: "easeInOut" },
                  opacity: { duration: 0.2, delay: 0.15, ease: "easeOut" }
                },
                style: { overflow: "hidden", width: "100%" },
                children: /* @__PURE__ */ e(Xn, {})
              },
              `pending-${be}`
            )),
            n.map(($, be) => /* @__PURE__ */ e(
              gt.div,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0 },
                transition: {
                  opacity: { duration: 0.2, ease: "easeOut" },
                  height: { duration: 0.3, delay: 0.15, ease: "easeInOut" },
                  paddingTop: { duration: 0.3, delay: 0.15, ease: "easeInOut" },
                  marginBottom: { duration: 0.3, delay: 0.15, ease: "easeInOut" }
                },
                style: {
                  overflow: "hidden",
                  width: "100%",
                  paddingTop: "0.5rem",
                  marginBottom: "0.75rem"
                },
                children: /* @__PURE__ */ e(
                  At,
                  {
                    ...$,
                    currency: ($ == null ? void 0 : $.currency) ?? l ?? "EUR",
                    isQuantityDisabled: U,
                    isStockDisabled: Y,
                    isLoading: ie == null ? void 0 : ie($.id),
                    isCartBusy: k,
                    updateQuantity: J,
                    totalAmount: $.totalAmount,
                    unitAmount: $.unitAmount,
                    discountAmount: $.discountAmount,
                    leftQuantityTitle: B[be] || "",
                    unavailableMessage: Re.has($.productId) ? g : void 0,
                    quantityAvailable: $.quantityAvailable ?? 99,
                    onlyOneLineItemInCart: n.length === 1,
                    isMobile: h
                  }
                )
              },
              $.id
            ))
          ] }),
          ee && /* @__PURE__ */ e("div", { style: { marginBottom: "0.75rem", width: "100%" }, children: ee }),
          v == null ? void 0 : v.map(($) => {
            const be = $.reason === "outOfStock", Pt = $.reason === "notFulfillable" && !Ie.has($.productId);
            if (!be && !Pt) return null;
            const Nt = be ? M : g;
            return /* @__PURE__ */ e("div", { style: { marginBottom: "0.75rem", width: "100%" }, children: /* @__PURE__ */ e(
              At,
              {
                id: "",
                name: $.name,
                imageUrl: $.imageUrl,
                productId: $.productId,
                quantity: $.quantity,
                currency: $.currency ?? l ?? "EUR",
                totalAmount: $.totalAmount,
                isQuantityDisabled: !1,
                isQuantityUpdateDisabled: !0,
                updateQuantity: J,
                discountAmount: 0,
                totalDiscount: c,
                leftQuantityTitle: Nt,
                quantityAvailable: 0,
                unitAmount: $.unitAmount,
                isMobile: h
              }
            ) }, $.productId);
          })
        ]
      }
    ),
    t && /* @__PURE__ */ e(
      $n,
      {
        isOpen: Te,
        onOpen: pe,
        onClose: ke,
        title: o,
        position: "bottom",
        containerRef: void 0,
        size: "unset",
        children: /* @__PURE__ */ e(ne, { my: "2", px: "4", children: /* @__PURE__ */ e(
          _t,
          {
            discountApplyLabel: T,
            discountFinderLabel: f,
            discountInputLabel: D,
            discountErrorLabel: y,
            recommendedDiscountCodes: Q,
            discounts: E,
            giftCards: H,
            onDiscountAddClick: V,
            onDiscountRemove: I,
            onGiftCardRemove: C,
            isDiscountDisabled: !!z,
            isDiscountHidden: !!P,
            shouldFocusField: !!q,
            currency: l,
            Icon: _,
            setDiscountValue: X
          }
        ) })
      }
    )
  ] });
}, Mt = We(
  ({
    label: t,
    helper: r,
    error: a,
    isInvalid: o,
    isDisabled: n,
    isRequired: l = !0,
    value: c,
    trackingId: p,
    onChange: s,
    onFocus: u,
    variant: i,
    onBlur: F,
    ...S
  }, m) => {
    const [T, f] = L(!1), [D, x] = L(!!a), z = Ke(), { themeName: P } = ae(), U = P === "classic", Y = P === "custom", V = {
      bgGradient: "",
      bg: "var(--input-focus-border, #BEBBB4)",
      p: "1px"
    }, I = te(() => {
      const y = z == null ? void 0 : z.themedClasses;
      return {
        inputBorderStyle: (y == null ? void 0 : y.inputBorderStyle) ?? Qe,
        inputBorderGradientStyle: (y == null ? void 0 : y.inputBorderGradientStyle) ?? et,
        inputBorderDisabledStyle: (y == null ? void 0 : y.inputBorderDisabledStyle) ?? ot,
        inputBorderInvalidStyle: (y == null ? void 0 : y.inputBorderInvalidStyle) ?? tt,
        inputBorderEmptyStyle: (y == null ? void 0 : y.inputBorderEmptyStyle) ?? rt,
        inputBackgroundGradientStyle: (y == null ? void 0 : y.inputBackgroundGradientStyle) ?? nt,
        inputBackgroundDisabledStyle: (y == null ? void 0 : y.inputBackgroundDisabledStyle) ?? at,
        inputBackgroundEmptyStyle: (y == null ? void 0 : y.inputBackgroundEmptyStyle) ?? it,
        inputBackgroundInvalidStyle: (y == null ? void 0 : y.inputBackgroundInvalidStyle) ?? lt,
        inputBoxShadowGradientStyle: (y == null ? void 0 : y.inputBoxShadowGradientStyle) ?? st
      };
    }, [z]), C = W(
      (y) => {
        s == null || s(y), x(!1);
      },
      [s, x]
    );
    return K(() => {
      x(!!a);
    }, [a, x]), /* @__PURE__ */ d(
      Ae,
      {
        variant: "floating",
        isRequired: l,
        isInvalid: !!o,
        isDisabled: !!n,
        width: "full",
        children: [
          /* @__PURE__ */ e(
            w,
            {
              _before: i !== "justUnstyled" && T && !D && !U && !Y ? I.inputBoxShadowGradientStyle : {},
              children: /* @__PURE__ */ e(
                w,
                {
                  ...i !== "justUnstyled" ? {
                    ...I.inputBorderStyle,
                    ...I.inputBorderGradientStyle,
                    ...Y ? V : {},
                    ...n ? I.inputBorderDisabledStyle : {},
                    ...!c && !T && !Y ? I.inputBorderEmptyStyle : {},
                    ...D ? I.inputBorderInvalidStyle : {}
                  } : {},
                  children: /* @__PURE__ */ d(xe, { justifyContent: "center", alignItems: "center", alignContent: "center", alignSelf: "center", children: [
                    /* @__PURE__ */ e(
                      De,
                      {
                        w: "full",
                        variant: "just",
                        placeholder: " ",
                        height: 14,
                        fontSize: "md",
                        textAlign: "left",
                        borderLeftRadius: i === "justUnstyled" ? "0" : "",
                        borderRightRadius: i === "justUnstyled" ? "1.875rem" : "",
                        errorBorderColor: "danger.main",
                        ...I.inputBackgroundGradientStyle,
                        ...n ? I.inputBackgroundDisabledStyle : {},
                        ...c ? {} : I.inputBackgroundEmptyStyle,
                        ...D || o ? I.inputBackgroundInvalidStyle : {},
                        borderColor: n ? "gray.602" : "transparent",
                        border: "",
                        pr: 12,
                        pl: "5",
                        value: c,
                        onChange: C,
                        onFocus: (y) => {
                          f(!0), u == null || u(y);
                        },
                        onBlur: (y) => {
                          f(!1), F == null || F(y);
                        },
                        ...S,
                        ref: m,
                        _disabled: { cursor: "default" },
                        "data-ph-capture-attribute-tracking-id": p
                      }
                    ),
                    t && /* @__PURE__ */ e(
                      Ze,
                      {
                        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                        fontSize: "md",
                        bg: "transparent",
                        style: {
                          backgroundColor: "transparent",
                          zIndex: "20"
                        },
                        children: t
                      }
                    )
                  ] })
                }
              )
            }
          ),
          r && /* @__PURE__ */ e(zt, { pl: "4", pb: "2", fontSize: "xs", children: r }),
          D && /* @__PURE__ */ e(
            ze,
            {
              position: "absolute",
              fontSize: "0.75rem",
              fontWeight: "350",
              zIndex: "5",
              w: "fit-content",
              color: "danger.main",
              bg: "var(--input-bg-error-message, #FFF)",
              borderRadius: "0.25rem",
              bottom: "-2",
              right: "5",
              px: "1",
              mb: "0.5",
              children: a
            }
          )
        ]
      }
    );
  }
), Ea = ({ name: t, control: r, onChange: a, onBlur: o, ...n }) => /* @__PURE__ */ e(
  Ht,
  {
    control: r,
    name: t,
    render: ({ field: l }) => /* @__PURE__ */ e(
      Mt,
      {
        ...n,
        ...l,
        value: l.value ?? "",
        onChange: (c) => {
          l.onChange(c), a == null || a(c);
        },
        onBlur: () => {
          l.onBlur(), o == null || o();
        }
      }
    )
  }
), ka = ({ isDisabled: t, children: r, ...a }) => /* @__PURE__ */ e(_e, { cursor: "pointer", size: "lg", colorScheme: "fullBlack", isDisabled: !!t, ...a, children: r }), Jn = ({
  value: t,
  onChange: r,
  iconComponent: a,
  options: o,
  ...n
}) => /* @__PURE__ */ d(
  w,
  {
    position: "relative",
    width: 24,
    className: "countrySelect",
    "data-ph-capture-attribute-tracking-id": "phone-number-country-select",
    children: [
      /* @__PURE__ */ e(w, { display: "flex", alignItems: "center", height: "100%", ml: 4, children: /* @__PURE__ */ e(a, { country: t ?? "", label: t ?? "" }) }),
      /* @__PURE__ */ e(
        Wt,
        {
          variant: "unstyled",
          position: "absolute",
          p: 0,
          top: 0,
          right: "0",
          display: "block",
          zIndex: 1,
          opacity: 0,
          _disabled: { opacity: 0, cursor: "not-allowed" },
          cursor: "pointer",
          value: t,
          mt: 4,
          onChange: (l) => r(l.target.value || void 0),
          "aria-label": "Phone number country",
          ...n,
          children: o.map(({ label: l, value: c }) => /* @__PURE__ */ e("option", { value: c, children: l }, c ?? "ZZ"))
        }
      )
    ]
  }
), Zn = {
  // apply Input Theme style
  ".isDisabled": {
    borderColor: "gray.602",
    color: "gray.603 !important",
    bg: "var(--input-bg-disabled, #FFF) !important"
  },
  ".isInvalid": {
    borderColor: "danger.main !important",
    background: "var(--input-bg-invalid, #FFF)"
  },
  ".PhoneInput:hover:not(.isDisabled) .countrySelect": {
    borderTop: 0,
    borderBottom: 0,
    borderLeft: 0
  },
  ".chakra-select__wrapper": {
    top: "-3px"
  }
}, wa = We(
  ({
    label: t,
    error: r,
    value: a,
    onChange: o,
    onFocus: n,
    defaultCountry: l,
    isRequired: c = !1,
    autoComplete: p = "on",
    ...s
  }, u) => {
    const i = (z) => {
      o == null || o(z);
    }, [F, S] = L(!1), { themeName: m } = ae(), T = m === "classic", f = te(
      () => ({
        // Base border style
        inputBorderStyle: {
          p: "1px",
          borderRadius: "1.875rem"
        },
        // Border states
        inputBorderGradientStyle: {
          background: "var(--input-border-filled)"
        },
        inputBorderInvalidStyle: {
          background: "var(--input-border-invalid) !important"
        },
        inputBorderEmptyStyle: {
          background: "var(--input-border-empty) !important"
        },
        inputBorderDisabledStyle: {
          background: "var(--input-border-disabled) !important"
        },
        // Background states
        inputBackgroundGradientStyle: {
          background: "var(--input-bg-filled) !important",
          backdropFilter: "var(--input-backdrop-filter, none)",
          WebkitBackdropFilter: "var(--input-backdrop-filter, none)",
          boxShadow: "var(--input-box-shadow-filled, none)"
        },
        inputBackgroundDisabledStyle: {
          background: "var(--input-bg-disabled) !important"
        },
        inputBackgroundEmptyStyle: {
          background: "var(--input-bg-empty)"
        },
        inputBackgroundInvalidStyle: {
          background: "var(--input-bg-invalid)"
        },
        // Focus box shadow
        inputBoxShadowGradientStyle: {
          borderRadius: "1.875rem",
          filter: "var(--input-focus-blur, blur(4px))",
          content: '""',
          position: "absolute",
          top: "-1px",
          right: "-1px",
          bottom: "-1px",
          left: "-1px",
          background: "var(--input-focus-shadow-bg, var(--input-border-filled))",
          bgClip: "border-box"
        }
      }),
      []
    );
    return /* @__PURE__ */ d(w, { position: "relative", children: [
      /* @__PURE__ */ e(w, { _before: { ...F && !T ? f.inputBoxShadowGradientStyle : {} }, children: /* @__PURE__ */ e(
        w,
        {
          ...f.inputBorderStyle,
          ...f.inputBorderGradientStyle,
          ...s.isDisabled ? f.inputBorderDisabledStyle : {},
          ...!a && !F ? f.inputBorderEmptyStyle : {},
          ...r ? f.inputBorderInvalidStyle : {},
          children: /* @__PURE__ */ e(w, { bg: "var(--input-bg, #FFF)", borderRadius: "1.875rem", children: /* @__PURE__ */ e(
            w,
            {
              __css: {
                ...Zn,
                ".PhoneInput": {
                  borderRadius: "1.875rem",
                  ...f.inputBackgroundGradientStyle,
                  ...s.isDisabled ? f.inputBackgroundDisabledStyle : {},
                  ...!a && !F ? f.inputBackgroundEmptyStyle : {},
                  ...r ? f.inputBackgroundInvalidStyle : {},
                  ...F ? f.inputBackgroundInvalidStyle : {}
                },
                // custom flag icon
                ".PhoneInputCountryIcon--border": {
                  ...f.inputBackgroundGradientStyle,
                  ...s.isDisabled ? f.inputBackgroundDisabledStyle : {},
                  ...!a && !F ? f.inputBackgroundEmptyStyle : {},
                  ...r ? f.inputBackgroundInvalidStyle : {},
                  ...F ? f.inputBackgroundInvalidStyle : {},
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  borderRadius: "2px",
                  overflow: "hidden"
                },
                // custom country select
                ".PhoneInput .countrySelect": {
                  borderLeftRadius: "1.875rem",
                  background: F ? "var(--input-bg, #FFF)" : "",
                  color: "var(--text, #1C1C1C)"
                }
              },
              children: /* @__PURE__ */ e(
                ur,
                {
                  className: `${s.isInvalid ? "isInvalid" : ""} ${s.isDisabled ? "isDisabled" : ""}`,
                  style: {
                    alignItems: "stretch",
                    backgroundColor: r || s.isInvalid ? "danger.main !important" : s.isDisabled || !a ? "var(--input-bg-disabled, #FFF) !important" : ""
                  },
                  defaultCountry: l ?? "FR",
                  value: a ?? "",
                  ref: u ?? void 0,
                  onChange: i,
                  onFocus: (z) => {
                    S(!0), n == null || n(z);
                  },
                  onBlur: () => {
                    S(!1);
                  },
                  label: t,
                  isRequired: c,
                  variant: "justUnstyled",
                  inputComponent: Mt,
                  disabled: !!s.isDisabled,
                  autoComplete: p,
                  countrySelectComponent: Jn,
                  ...s
                }
              )
            }
          ) })
        }
      ) }),
      r && /* @__PURE__ */ e(Ae, { isInvalid: !!s.isInvalid, children: /* @__PURE__ */ e(
        ze,
        {
          position: "absolute",
          fontSize: "0.625rem",
          fontWeight: "350",
          color: "danger.main",
          borderRadius: "0.25rem",
          bg: "var(--input-bg-error-message, #FFF)",
          bottom: "-2",
          right: "5",
          px: "1",
          mb: "0.5",
          zIndex: "5",
          children: r
        }
      ) })
    ] });
  }
), Ia = ({
  trackingId: t,
  placeholder: r,
  label: a,
  isDisabled: o,
  subtitle: n,
  onClick: l,
  reverse: c,
  isInvalid: p = !1,
  error: s,
  Icon: u,
  variant: i,
  PlaceholderDropdownAriaDescription: F,
  id: S
}) => {
  const m = te(
    () => ({
      // Base border style
      inputBorderStyle: {
        p: "1px",
        borderRadius: "1.875rem"
      },
      // Border states
      inputBorderGradientStyle: {
        background: "var(--input-border-filled)"
      },
      inputBorderInvalidStyle: {
        background: "var(--input-border-invalid) !important"
      },
      inputBorderEmptyStyle: {
        background: "var(--input-border-empty) !important"
      },
      inputBorderDisabledStyle: {
        background: "var(--input-border-disabled) !important"
      },
      // Background states
      inputBackgroundGradientStyle: {
        background: "var(--input-bg-filled) !important",
        backdropFilter: "var(--input-backdrop-filter, none)",
        WebkitBackdropFilter: "var(--input-backdrop-filter, none)",
        boxShadow: "var(--input-box-shadow-filled, none)"
      },
      inputBackgroundDisabledStyle: {
        background: "var(--input-bg-disabled) !important"
      },
      inputBackgroundEmptyStyle: {
        background: "var(--input-bg-empty)"
      },
      inputBackgroundInvalidStyle: {
        background: "var(--input-bg-invalid)"
      }
    }),
    []
  ), T = "var(--input-disabled-bg-variant, #F7F7F7)", f = "var(--text, #1C1C1C)";
  return /* @__PURE__ */ e(
    w,
    {
      ...m.inputBorderStyle,
      ...a ? m.inputBorderGradientStyle : {},
      ...o ? m.inputBorderDisabledStyle : {},
      ...a ? {} : m.inputBorderEmptyStyle,
      ...s || p ? m.inputBorderInvalidStyle : {},
      onClick: () => !o && (l == null ? void 0 : l()),
      id: S,
      "aria-description": F,
      "data-ph-capture-attribute-tracking-id": t,
      children: /* @__PURE__ */ d(
        w,
        {
          w: "full",
          height: 14,
          display: "flex",
          px: 4,
          fontSize: "md",
          borderRadius: "1.875rem",
          cursor: o ? "default" : "pointer",
          ...m.inputBackgroundGradientStyle,
          ...o ? m.inputBackgroundDisabledStyle : {},
          ...!a && !o ? m.inputBackgroundEmptyStyle : {},
          ...s || p ? m.inputBackgroundInvalidStyle : {},
          borderColor: o ? "gray.602" : "transparent",
          bgColor: o ? "var(--input-bg-disabled, #ffffff)" : "var(--input-bg, white)",
          position: "relative",
          alignItems: "center",
          sx: i === "disabledAddresses" ? {
            background: `${T} !important`
          } : {},
          children: [
            /* @__PURE__ */ e(w, { mr: "2", boxSize: "2rem", children: u && /* @__PURE__ */ e(
              u,
              {
                fill: i === "disabledAddresses" ? "#8F8F8F" : a ? f : "var(--text-secondary, #585858)",
                alt: "placeholderDropdown icon"
              }
            ) }),
            r && !a && /* @__PURE__ */ e(b, { fontSize: "md", fontWeight: "normal", color: "gray.603", children: r }),
            a && /* @__PURE__ */ d(N, { direction: c ? "column-reverse" : "column", ml: "2", children: [
              /* @__PURE__ */ e(b, { noOfLines: 1, fontSize: "md", fontWeight: "normal", lineHeight: "24px", color: f, children: a }),
              n && /* @__PURE__ */ e(b, { noOfLines: 1, fontSize: "11px", fontWeight: "normal", lineHeight: "16px", color: f, children: n })
            ] })
          ]
        }
      )
    }
  );
}, Qn = (t) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...t,
    children: [
      /* @__PURE__ */ e("path", { d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" }),
      /* @__PURE__ */ e("path", { d: "m15 5 4 4" })
    ]
  }
), _a = ({
  placeholder: t,
  label: r,
  isDisabled: a,
  subtitle: o,
  onClick: n,
  reverse: l,
  Icon: c,
  cardBrand: p
}) => /* @__PURE__ */ d(
  je,
  {
    onClick: () => !a && (n == null ? void 0 : n()),
    w: "full",
    height: "3.5rem",
    display: "flex",
    px: 4,
    py: 3,
    fontSize: "md",
    borderRadius: "0.875rem",
    cursor: a ? "not-allowed" : "pointer",
    position: "relative",
    alignItems: "center",
    variant: "gradient",
    children: [
      p && c && /* @__PURE__ */ d(O, { spacing: "4", children: [
        /* @__PURE__ */ e(c, { brand: p }),
        /* @__PURE__ */ d(ce, { align: "baseline", spacing: -4, children: [
          r && /* @__PURE__ */ e(
            b,
            {
              color: "var(--text, #1C1C1C)",
              fontSize: "md",
              fontStyle: "normal",
              fontWeight: "350",
              lineHeight: "6",
              children: r
            }
          ),
          o && /* @__PURE__ */ e(
            b,
            {
              fontWeight: "medium",
              color: "var(--text-secondary, #585858)",
              fontSize: "xs",
              fontStyle: "normal",
              lineHeight: "4",
              children: o
            }
          )
        ] }),
        /* @__PURE__ */ e(
          w,
          {
            position: "absolute",
            top: "50%",
            right: "4",
            transform: "translateY(-50%)",
            color: "var(--text-secondary, #585858)",
            "aria-hidden": "true",
            children: /* @__PURE__ */ e(Qn, { width: "16", height: "16", color: "var(--text-secondary, #585858)" })
          }
        )
      ] }),
      t && !r && !p && !c && /* @__PURE__ */ e(b, { fontSize: "1rem", fontWeight: "350", color: "gray.603", children: t }),
      r && !p && !c && /* @__PURE__ */ d(N, { direction: l ? "column-reverse" : "column", children: [
        /* @__PURE__ */ e(
          b,
          {
            noOfLines: 1,
            fontSize: "1rem",
            fontWeight: "350",
            lineHeight: "24px",
            color: a ? "gray.300" : "var(--text, #1C1C1C)",
            children: r
          }
        ),
        o && /* @__PURE__ */ e(
          b,
          {
            noOfLines: 1,
            fontSize: "12px",
            fontWeight: "350",
            lineHeight: "16px",
            color: a ? "gray.300" : "var(--text-secondary, #585858)",
            children: o
          }
        )
      ] })
    ]
  }
), Aa = ({ passwordSize: t, onComplete: r, onChange: a, onError: o, error: n, ...l }) => {
  const c = re(null), [p, s] = L(""), [u, i] = L("typing"), [F, S] = L(), m = W(
    async (x) => {
      try {
        i("gradient"), S(void 0), await (r == null ? void 0 : r(x));
      } catch {
        i("error"), S("wrong");
      }
    },
    [r]
  ), T = W(
    (x) => {
      (x.key === "Enter" || x.keyCode === 13) && p.length < t && (S("incomplete"), i("error"));
    },
    [p.length, t]
  ), f = W(
    (x) => {
      x.currentTarget.value.length > t || (s(x.currentTarget.value), a == null || a(x.currentTarget.value), S(void 0), i("typing"), x.currentTarget.value.length === t && m(x.currentTarget.value));
    },
    [t, a, m]
  );
  return K(() => {
    o == null || o(F);
  }, [F, o]), K(() => {
    p.length > 0 && i("gradient");
  }, [p.length, i]), /* @__PURE__ */ d(le, { children: [
    /* @__PURE__ */ e(
      je,
      {
        height: "3.5rem",
        variant: u,
        ...{
          borderRadius: "1.875rem",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem 2rem",
          gap: "4"
        },
        w: "full",
        alignItems: "center",
        onClick: () => {
          var x;
          return (x = c.current) == null ? void 0 : x.focus();
        },
        children: /* @__PURE__ */ e(
          De,
          {
            "data-ph-capture-attribute-tracking-id": "pin-input",
            onKeyDown: T,
            onChange: f,
            value: p,
            ref: c,
            variant: "unstyled",
            placeholder: "✦✦✦✦✦✦",
            letterSpacing: "1.8rem",
            type: "text",
            inputMode: "numeric",
            pattern: "[0-9]*",
            autoComplete: "one-time-code",
            maxLength: t,
            m: "auto",
            w: "220px",
            ...l
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        py: "1.5",
        pl: "1.5",
        pr: "3",
        m: "auto",
        alignItems: "center",
        gap: "1",
        borderRadius: "1.25rem",
        bg: "danger.main",
        color: "white",
        fontSize: "sm",
        fontWeight: "350",
        lineHeight: "5",
        display: F ? "block" : "none",
        children: n
      }
    )
  ] });
}, ea = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.54093%200.00444388C6.03138%200.0269591%205.58306%200.0916887%205.12653%200.208668C3.76217%200.558261%202.55796%201.30757%201.63548%202.38094C0.7225%203.44327%200.156087%204.77825%200.0292969%206.16654C-0.00638949%206.55731%20-0.00872549%206.99172%200.0227817%207.37614C0.132657%208.71657%200.639697%209.99377%201.48116%2011.0497C1.75224%2011.3899%202.08093%2011.7275%202.42576%2012.02C3.20056%2012.677%204.15341%2013.1642%205.15533%2013.4155C6.12313%2013.6582%207.16946%2013.6823%208.1558%2013.4846C9.13938%2013.2874%2010.0862%2012.863%2010.8907%2012.2587C10.9488%2012.2151%2010.9982%2012.1793%2011.0005%2012.1793C11.0029%2012.1793%2011.8241%2012.9982%2012.8256%2013.9991C13.9925%2015.1652%2014.6661%2015.8338%2014.7009%2015.8605C14.7658%2015.9103%2014.8331%2015.954%2014.886%2015.9807L14.9246%2016.0001H15.1713H15.418L15.463%2015.9775C15.6635%2015.8766%2015.8765%2015.6635%2015.9775%2015.463L16.0001%2015.4181V15.1713V14.9246L15.9807%2014.886C15.954%2014.8331%2015.9102%2014.7658%2015.8605%2014.7009C15.8338%2014.6661%2015.1652%2013.9925%2013.9991%2012.8257C12.9982%2011.8242%2012.1793%2011.0029%2012.1793%2011.0006C12.1793%2010.9983%2012.215%2010.9488%2012.2587%2010.8907C12.7674%2010.2135%2013.1516%209.43003%2013.3765%208.61134C13.66%207.57898%2013.6937%206.45987%2013.473%205.40494C13.2785%204.4753%2012.8721%203.56239%2012.3127%202.799C12.0907%202.49598%2011.8961%202.26987%2011.6197%201.99348C11.4056%201.77953%2011.2611%201.6496%2011.0497%201.48118C10.3533%200.926249%209.55561%200.513519%208.70093%200.265941C8.18423%200.116271%207.6737%200.0326999%207.11693%200.00665188C6.99414%200.000904676%206.6508%20-0.000407324%206.54093%200.00444388ZM6.56333%201.66187C6.54925%201.66296%206.48877%201.66702%206.42893%201.6709C5.44838%201.73442%204.45692%202.1129%203.66413%202.72633C3.22196%203.06846%202.82226%203.49694%202.51603%203.95714C2.06999%204.62742%201.78667%205.39731%201.69318%206.1931C1.66525%206.43084%201.66091%206.51623%201.66132%206.81934C1.66172%207.11987%201.66775%207.22925%201.69648%207.45738C1.79583%208.24627%202.076%208.99733%202.52088%209.66734C2.80343%2010.0929%203.19346%2010.5163%203.60427%2010.8434C4.09778%2011.2364%204.6566%2011.5329%205.26733%2011.726C6.0863%2011.9849%206.99655%2012.0307%207.84741%2011.8558C8.64251%2011.6924%209.39508%2011.3391%2010.0257%2010.833C10.1694%2010.7177%2010.2622%2010.6343%2010.4215%2010.4773C10.6895%2010.2131%2010.8909%209.97183%2011.0845%209.68334C11.748%208.69477%2012.0469%207.5233%2011.9391%206.33448C11.8489%205.33981%2011.4661%204.38607%2010.8434%203.60429C10.6842%203.40442%2010.4354%203.13957%2010.2573%202.98053C9.79239%202.56512%209.2932%202.25381%208.72653%202.0259C8.20294%201.81531%207.66968%201.69708%207.09542%201.66427C6.99326%201.65844%206.62904%201.6568%206.56333%201.66187Z'%20fill='%238F8F8F'/%3e%3c/svg%3e", ta = ({
  trackingId: t,
  isDisabled: r,
  onClick: a,
  label: o,
  placeholder: n,
  error: l = "",
  isRequired: c = !0
}) => {
  var i, F, S;
  const p = ar(), s = Ke(), u = (S = (F = (i = s == null ? void 0 : s.components) == null ? void 0 : i.Input) == null ? void 0 : F.variants) != null && S.just ? s : Ut;
  return /* @__PURE__ */ d(Ae, { variant: "mobileSelect", isInvalid: !!l, isDisabled: !!r, isRequired: c, children: [
    /* @__PURE__ */ d(
      je,
      {
        "data-ph-capture-attribute-tracking-id": t,
        borderRadius: "1.875rem",
        variant: "gradient",
        position: "relative",
        cursor: r ? "not-allowed" : "pointer",
        height: 14,
        fontSize: "md",
        onClick: () => !r && a(),
        pr: 12,
        pl: 4,
        pt: "25px",
        className: `${l ? " errored" : ""}${o === "" ? " empty" : ""}${r ? " disabled" : ""}`,
        __css: {
          "&.focused": {
            ...u.components.Input.variants.just.field._active
          },
          "&.errored": {
            ...u.components.Input.variants.just.field._invalid
          },
          "&.focused + label, &:not(.empty) + label": {
            ...u.components.Form.variants.floating.container._focusWithin.label,
            ...u.components.Form.variants.floating.container._hover.label
          },
          "&.disabled": {
            ...u.components.Input.variants.just.field._disabled
          },
          ...u.components.Input.variants.just.field
        },
        children: [
          o && /* @__PURE__ */ e(
            b,
            {
              noOfLines: 1,
              fontSize: "1rem",
              color: r ? jt.color : "var(--text, #1C1C1C)",
              bg: "transparent",
              children: o
            }
          ),
          /* @__PURE__ */ e(
            dr,
            {
              right: "10px",
              top: "15px",
              color: r ? "gray.100" : "inherit",
              position: "absolute",
              fontSize: "2xl"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e(
      Ze,
      {
        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
        htmlFor: p,
        bg: "transparent",
        style: {
          backgroundColor: "transparent"
        },
        children: n
      }
    ),
    l && /* @__PURE__ */ e(ze, { pl: "4", fontSize: "xs", color: "danger.text", children: l })
  ] });
}, ra = 10, oa = 500, Me = (t, r) => {
  const a = Oe(t.label).toLowerCase(), o = Oe(r.label).toLowerCase();
  return a < o ? -1 : a > o ? 1 : 0;
}, Da = We(
  ({
    trackingId: t,
    searchTrackingId: r,
    optionTrackingId: a,
    options: o,
    favoriteOptions: n,
    label: l,
    searchLabel: c,
    onChange: p,
    value: s = "",
    error: u,
    name: i,
    isSearchable: F = !0,
    isRequired: S = !0,
    isDisabled: m = !1,
    dataAutocomplete: T
  }, f) => {
    const { isOpen: D, onClose: x, onToggle: z } = qt(), [P, U] = L(""), [Y, V] = L(""), I = re(null), C = () => {
      U(""), x();
    };
    K(() => {
      if (I.current && !Y) {
        const _ = I.current.getBoundingClientRect(), j = window.scrollY + window.innerHeight, M = _.top + window.scrollY;
        V(`${j - M - ra}px`);
      }
    }, [D, Y]);
    const y = te(
      () => n != null && n.length ? n.filter((_) => _.value !== s).sort(Me) : [],
      [n, s]
    ), E = te(() => {
      if (!P) return o.filter((M) => !(n != null && n.includes(M))).sort(Me);
      const j = P.toLowerCase().split(" ");
      return o.filter((M) => Oe(M.label).toLowerCase().split(" ").some((v) => j.some((h) => v.startsWith(h))) && !(n != null && n.includes(M))).sort(Me);
    }, [o, P, n]), q = mr((_) => {
      var j;
      U(((j = _.target.value) == null ? void 0 : j.trim()) ?? "");
    }, oa);
    K(() => () => {
      q.cancel();
    }, []);
    const J = te(
      () => {
        var _;
        return ((_ = o.find((j) => j.value === s)) == null ? void 0 : _.label) ?? "";
      },
      [o, s]
    ), Z = W((_) => {
      var M, g;
      const j = document.querySelector(`[name="${i}"]`);
      j && ((g = (M = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) == null ? void 0 : M.set) == null || g.call(
        j,
        _
      ), j.dispatchEvent(new Event("change", { bubbles: !0 })));
    }, []), B = W((_) => {
      const j = o.find((M) => M.value === _.target.value);
      p == null || p(j == null ? void 0 : j.value), C();
    }, []);
    return /* @__PURE__ */ d(w, { position: "relative", children: [
      /* @__PURE__ */ e(
        ta,
        {
          trackingId: t,
          label: J,
          placeholder: l,
          onClick: z,
          isRequired: S,
          isDisabled: m,
          error: u
        }
      ),
      /* @__PURE__ */ e(
        "input",
        {
          type: "text",
          style: { display: "none" },
          name: i,
          "data-autocomplete": T,
          value: s,
          onChange: B
        }
      ),
      D && /* @__PURE__ */ e(
        w,
        {
          overflow: "hidden",
          position: "absolute",
          top: "63px",
          left: "0",
          width: "full",
          height: Y,
          maxH: "500px",
          backgroundColor: "var(--card-bg, white)",
          zIndex: 5,
          ref: I,
          padding: 4,
          borderRadius: "24px",
          border: "1px solid",
          borderColor: "gray.602",
          boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.05), -2px -2px 12px 0px rgba(0, 0, 0, 0.05);",
          children: /* @__PURE__ */ d(ne, { spacing: 4, overflow: "hidden", maxH: "100%", children: [
            F && /* @__PURE__ */ d(xe, { position: "relative", rounded: "md", children: [
              /* @__PURE__ */ e(
                De,
                {
                  "data-ph-capture-attribute-tracking-id": r,
                  onChange: q,
                  bg: "var(--card-bg, #FFF)",
                  placeholder: c,
                  padding: "8px 12px 8px 44px"
                }
              ),
              /* @__PURE__ */ e(Dt, { children: /* @__PURE__ */ e(Je, { src: ea, alt: "search icon", width: "16px", height: "16px", mt: "4", ml: "1" }) })
            ] }),
            s && /* @__PURE__ */ e(_e, { size: "lg", isReadOnly: !0, colorScheme: "fullBlack", isChecked: !0, mb: 2.5, children: J }),
            /* @__PURE__ */ d(Vt, { onChange: Z, value: s, ref: f, overflow: "scroll", children: [
              y.length ? /* @__PURE__ */ e(ce, { spacing: 6, alignItems: "start", mb: 3, children: y == null ? void 0 : y.map(({ value: _, label: j }) => /* @__PURE__ */ e(
                _e,
                {
                  variant: "nofloating",
                  display: _ === s ? "none" : "flex",
                  size: "lg",
                  w: "full",
                  isChecked: _ === s,
                  colorScheme: "fullBlack",
                  value: _,
                  "data-ph-capture-attribute-tracking-id": a,
                  children: /* @__PURE__ */ e("span", { "data-ph-capture-attribute-tracking-id": a, children: j })
                },
                _
              )) }) : /* @__PURE__ */ e(le, {}),
              /* @__PURE__ */ e(se, { borderStyle: "dashed" }),
              /* @__PURE__ */ e(ce, { spacing: 6, mt: 3, alignItems: "start", children: E.map(({ value: _, label: j }) => /* @__PURE__ */ e(
                _e,
                {
                  variant: "nofloating",
                  display: _ === s ? "none" : "flex",
                  size: "lg",
                  w: "full",
                  isChecked: _ === s,
                  colorScheme: "fullBlack",
                  value: _,
                  "data-ph-capture-attribute-tracking-id": a,
                  children: /* @__PURE__ */ e("span", { "data-ph-capture-attribute-tracking-id": a, children: j })
                },
                _
              )) })
            ] })
          ] })
        }
      )
    ] });
  }
), za = ({
  icon: t,
  title: r,
  sentence: a,
  accept: o,
  decline: n,
  acceptColor: l,
  containerRef: c,
  onDecline: p,
  onAccept: s,
  isOpen: u
}) => {
  const i = re(null);
  return /* @__PURE__ */ d(
    Xt,
    {
      portalProps: {
        containerRef: c
      },
      motionPreset: "slideInBottom",
      leastDestructiveRef: i,
      onClose: p,
      isOpen: u,
      children: [
        /* @__PURE__ */ e(Ot, {}),
        /* @__PURE__ */ d(
          Kt,
          {
            maxW: "18rem",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.25rem",
            p: "6",
            bg: "var(--card-bg, #FFF)",
            color: "var(--text, #1C1C1C)",
            children: [
              /* @__PURE__ */ e(w, { display: "flex", justifyContent: "center", pb: "6", children: t }),
              /* @__PURE__ */ e(
                Jt,
                {
                  pb: "2",
                  px: "0",
                  pt: "0",
                  color: "var(--text, #1C1C1C)",
                  textAlign: "center",
                  fontWeight: "medium",
                  lineHeight: "6",
                  children: r
                }
              ),
              /* @__PURE__ */ e(
                Zt,
                {
                  fontSize: "0.8125rem",
                  color: "var(--text, #1C1C1C)",
                  textAlign: "center",
                  lineHeight: "5",
                  pb: "4",
                  px: "0",
                  pt: "0",
                  children: a
                }
              ),
              /* @__PURE__ */ e(Qt, { p: "0", children: /* @__PURE__ */ d(ne, { width: "100%", gap: "4", children: [
                /* @__PURE__ */ e(se, { borderColor: "var(--border, #E0E0E0)" }),
                /* @__PURE__ */ e(
                  de,
                  {
                    variant: "ghost",
                    color: l ?? "var(--text, #1C1C1C)",
                    onClick: s,
                    _hover: {
                      bg: "var(--border, #E0E0E0)"
                    },
                    children: o
                  }
                ),
                /* @__PURE__ */ e(se, { borderColor: "var(--border, #E0E0E0)" }),
                /* @__PURE__ */ e(
                  de,
                  {
                    onClick: p,
                    variant: "ghost",
                    color: "var(--text, #1C1C1C)",
                    _hover: {
                      bg: "var(--border, #E0E0E0)"
                    },
                    children: n
                  }
                )
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, Wa = ({ children: t, ...r }) => /* @__PURE__ */ e(b, { lineHeight: "24px", fontSize: "1.125rem", className: "leaf__heading", ...r, children: t }), Ha = ({ children: t, ...r }) => /* @__PURE__ */ e(b, { lineHeight: "6", fontSize: "md", fontStyle: "normal", fontWeight: "350", className: "leaf__body", ...r, children: t }), ja = ({ children: t, ...r }) => /* @__PURE__ */ e(b, { fontSize: "md", fontWeight: "medium", lineHeight: "6", className: "leaf__caption", ...r, children: t }), Ua = ({ children: t, ...r }) => /* @__PURE__ */ e(
  b,
  {
    color: "#1C1C1C",
    fontSize: "0.75rem",
    lineHeight: "20px",
    fontWeight: 600,
    className: "leaf__info",
    ...r,
    children: t
  }
), $a = ({ components: t, show: r }) => /* @__PURE__ */ e(le, { children: t[r] }), Ga = ({ back: t, onBack: r, isOpen: a, children: o, variantButton: n, ...l }) => a ? /* @__PURE__ */ e(
  w,
  {
    position: "absolute",
    top: "0",
    left: "0",
    as: "main",
    flex: "1 1 auto",
    overflow: "auto",
    p: "0",
    m: "0",
    height: "full",
    width: "full",
    display: "flex",
    backgroundColor: "var(--toast-overlay-bg) !important",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    alignSelf: "center",
    zIndex: "10000",
    children: /* @__PURE__ */ d(
      ne,
      {
        display: "flex",
        alignItems: "flex-start",
        alignSelf: "center",
        backgroundColor: "var(--toast-bg)",
        w: "21.56rem",
        minH: "16rem",
        maxH: "80vh",
        borderRadius: "1.5rem",
        border: "1px solid",
        borderColor: "var(--toast-border)",
        boxShadow: "var(--toast-shadow)",
        pt: "8",
        px: "6",
        pb: "6",
        alignContent: "center",
        justifyContent: "space-between",
        ...l,
        children: [
          /* @__PURE__ */ e(w, { flex: "1", overflowY: "auto", w: "full", children: o }),
          /* @__PURE__ */ e(
            He,
            {
              onClick: () => {
                r(void 0);
              },
              variant: n ?? "secondary",
              label: t,
              w: "full",
              h: "14",
              mt: "4"
            }
          )
        ]
      }
    )
  }
) : /* @__PURE__ */ e(le, {}), Ta = ({ loadingColor: t, delay: r, duration: a, ...o }) => /* @__PURE__ */ e(w, { className: "loading-container", ...o, children: /* @__PURE__ */ e(w, { className: "loading-bar", bgColor: t, animation: `loadingAnimation ${a ?? 1800}ms ${r ?? 0}ms infinite` }) }), na = 15, Ra = ({
  labels: t,
  disabled: r,
  products: a,
  onAddToCart: o,
  variantIdsInCart: n,
  onRemoveFromCart: l,
  showQuantityAvailable: c = !1,
  onDisplay: p
}) => {
  const [s, u] = L(0), [i, F] = L({}), S = re(null), m = re([]), T = er({ base: !0, md: !1 }), [f, D] = L(!1), x = re(0), z = re(0), { themeName: P } = ae(), U = te(
    () => ({
      cardBg: "var(--upsell-card-bg)",
      cardBgActive: "var(--upsell-card-bg-active)",
      borderActive: "var(--upsell-border-active)",
      borderDefault: "var(--upsell-border-default)",
      btnBgActive: "var(--upsell-btn-bg-active)",
      btnBgDelete: "var(--upsell-btn-bg-delete)",
      btnTextActive: "var(--upsell-btn-text-active)",
      textColor: "var(--upsell-text)",
      iconColor: "var(--upsell-icon)"
    }),
    [P]
  ), Y = re(n), [V, I] = L(null), C = te(() => a.filter(
    ({ variants: g = [] }) => g.some((A) => Y.current.includes(A.id)) === !1
  ).slice(0, na), [a, Y]);
  K(() => {
    p && C.length > 0 && p(C);
  }, [C, p]);
  const y = W(
    (g) => {
      const A = i[g.id], v = g.variants.filter((h) => h.available);
      return v.find((h) => h.id === A) ?? v[0];
    },
    [i]
  ), E = W((g, A) => {
    F((v) => ({
      ...v,
      [g]: A
    }));
  }, []), H = W((g) => {
    var A;
    !(S != null && S.current) || !(m != null && m.current[g]) || (A = m.current[g]) == null || A.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, []), q = W(() => {
    const g = Math.max(0, s - 1);
    H(g);
  }, [s, H]), J = W(() => {
    const g = Math.min(C.length - 1, s + 1);
    H(g);
  }, [s, C.length, H]), Z = W((g) => {
    S.current && (D(!0), x.current = g.pageX, z.current = S.current.scrollLeft);
  }, []), B = W(
    (g) => {
      if (!f || !S.current) return;
      g.preventDefault();
      const v = (g.pageX - x.current) * 2;
      S.current.scrollLeft = z.current - v;
    },
    [f]
  ), _ = W(() => {
    D(!1);
  }, []), j = W(() => {
    D(!1);
  }, []);
  K(() => {
    if (!S.current) return;
    m.current = m.current.slice(0, C.length);
    const g = {
      root: S.current,
      rootMargin: "0px",
      threshold: 0.7
      // Element is considered visible when 70% in view
    }, A = (h) => {
      const X = h.reduce((Q, oe) => oe.intersectionRatio > Q.intersectionRatio ? oe : Q, h[0]);
      if (X.isIntersecting) {
        const Q = m.current.findIndex((oe) => oe === X.target);
        Q !== -1 && Q !== s && u(Q);
      }
    }, v = new IntersectionObserver(A, g);
    return m.current.forEach((h) => {
      h && v.observe(h);
    }), () => v.disconnect();
  }, [C.length, s]);
  const M = W(async (g, A) => {
    I(A);
    try {
      await g();
    } finally {
      I(null);
    }
  }, []);
  return C.length === 0 ? null : /* @__PURE__ */ d(
    w,
    {
      mt: "4",
      width: "100%",
      position: "relative",
      pointerEvents: r ? "none" : "auto",
      cursor: r ? "not-allowed" : "auto",
      children: [
        /* @__PURE__ */ e(tr, { as: "h2", fontWeight: "500", fontSize: "lg", mb: 2, children: t.title }),
        /* @__PURE__ */ e(
          O,
          {
            spacing: 2,
            align: "stretch",
            ref: S,
            overflowX: "auto",
            overflowY: "hidden",
            position: "relative",
            onMouseUp: _,
            onMouseDown: Z,
            onMouseMove: B,
            onMouseLeave: j,
            css: {
              "&::-webkit-scrollbar": {
                display: "none"
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              scrollBehavior: "smooth",
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              cursor: f ? "grabbing" : "grab"
            },
            children: C.map((g, A) => {
              const v = y(g), h = V === v.id, X = !h && n.includes(v.id), Q = X ? U.btnBgDelete : U.btnBgActive, oe = X ? U.textColor : U.btnTextActive, ie = g.variants.some((k) => n.includes(k.id));
              return /* @__PURE__ */ e(
                w,
                {
                  p: 3,
                  minW: "230px",
                  maxW: "300px",
                  flexShrink: 0,
                  borderWidth: "1px",
                  borderRadius: "16px",
                  transition: "all 0.3s ease-in",
                  borderColor: ie ? U.borderActive : U.borderDefault,
                  background: ie ? U.cardBgActive : U.cardBg,
                  ref: (k) => {
                    m.current[A] = k;
                  },
                  css: {
                    userSelect: "none",
                    scrollSnapAlign: "start"
                  },
                  children: /* @__PURE__ */ d(N, { gap: 2, alignItems: "center", children: [
                    /* @__PURE__ */ e(
                      Lt,
                      {
                        boxSize: "80px",
                        flexShrink: 0,
                        objectFit: "cover",
                        borderRadius: "md",
                        draggable: !1,
                        alt: g.name,
                        src: v == null ? void 0 : v.imageUrl,
                        background: "lightgray 50% / cover no-repeat"
                      }
                    ),
                    /* @__PURE__ */ d(ce, { align: "stretch", flex: 1, gap: 1, overflow: "hidden", children: [
                      /* @__PURE__ */ e(
                        b,
                        {
                          fontSize: "sm",
                          color: "var(--text, #1C1C1C)",
                          overflow: "hidden",
                          fontWeight: "medium",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          children: g.name
                        }
                      ),
                      /* @__PURE__ */ d(O, { align: "center", gap: 1, children: [
                        /* @__PURE__ */ e(b, { color: "var(--text-secondary, #585858)", fontSize: "xs", children: ve(v == null ? void 0 : v.price, {
                          currency: (v == null ? void 0 : v.currency) ?? "EUR"
                        }) }),
                        c && v.available && (v == null ? void 0 : v.quantityAvailable) && (v == null ? void 0 : v.quantityAvailable) > 0 && (v == null ? void 0 : v.quantityAvailable) < 10 && /* @__PURE__ */ d(le, { children: [
                          /* @__PURE__ */ e(se, { orientation: "vertical", h: "3", color: "gray.602" }),
                          /* @__PURE__ */ e(b, { color: "danger.main", fontSize: "xs", children: v.quantityAvailable === 1 ? t.leftQuantity.singular.replace(
                            "{{count}}",
                            v.quantityAvailable.toString()
                          ) : t.leftQuantity.plural.replace(
                            "{{count}}",
                            v.quantityAvailable.toString()
                          ) })
                        ] })
                      ] }),
                      /* @__PURE__ */ d(N, { gap: 1, mt: 1, children: [
                        g.variants && g.variants.length > 1 && /* @__PURE__ */ e(
                          Wt,
                          {
                            w: "100%",
                            minW: "120px",
                            size: "sm",
                            color: "var(--text, #1C1C1C)",
                            borderRadius: "16px",
                            borderColor: "gray.602",
                            isDisabled: !!V,
                            value: i[g.id],
                            _focus: { borderColor: "gray.602", boxShadow: "none" },
                            _focusVisible: { borderColor: "gray.602", boxShadow: "none" },
                            onChange: (k) => E(g.id, k.target.value),
                            children: g.variants.map((k) => /* @__PURE__ */ e("option", { value: k.id, disabled: !k.available, children: k.name }, k.id))
                          }
                        ),
                        /* @__PURE__ */ e(
                          de,
                          {
                            h: "32px",
                            py: "10px",
                            minW: "unset",
                            fontSize: "sm",
                            color: oe,
                            lineHeight: "1",
                            background: Q,
                            fontWeight: "medium",
                            backgroundClip: "padding-box",
                            "aria-label": t.addToCart,
                            transition: "background 300ms ease-in",
                            border: "1px solid",
                            borderColor: "gray.602",
                            px: g.variants.length > 1 ? "16px" : "10px",
                            _hover: { background: Q, backgroundClip: "padding-box" },
                            _active: { background: Q, backgroundClip: "padding-box" },
                            w: g.variants.length > 1 ? "32px" : "auto",
                            onClick: () => {
                              if (h) return;
                              const k = n.includes(v.id) ? () => l(v.id) : () => o(g, v);
                              M(k, v.id);
                            },
                            "data-ph-capture-attribute-tracking-id": X ? "upsell-carousel-remove-from-cart-button" : "upsell-carousel-add-to-cart-button",
                            children: /* @__PURE__ */ e(O, { gap: 1, alignItems: "center", children: h ? /* @__PURE__ */ e(rr, { size: "sm" }) : n.includes(v.id) ? /* @__PURE__ */ e(cr, { color: "var(--text)", w: 3, h: 3 }) : /* @__PURE__ */ d(le, { children: [
                              /* @__PURE__ */ e(pr, { w: 3, h: 3 }),
                              g.variants.length === 1 && /* @__PURE__ */ e(b, { children: t.addToCart })
                            ] }) })
                          }
                        )
                      ] })
                    ] })
                  ] })
                },
                g.id
              );
            })
          }
        ),
        T ? /* @__PURE__ */ e(O, { justify: "center", mt: 4, spacing: 2, children: C.map((g, A) => /* @__PURE__ */ e(
          w,
          {
            w: "10px",
            h: "10px",
            cursor: "pointer",
            border: "1px solid",
            borderRadius: "full",
            borderColor: "gray.603",
            onClick: () => H(A),
            bg: s === A ? "gray.603" : "transparent"
          },
          A
        )) }) : /* @__PURE__ */ d(N, { flexDir: "row", w: "full", gap: 6, alignItems: "center", justifyContent: "center", mt: 4, children: [
          /* @__PURE__ */ e(
            pt,
            {
              w: 6,
              h: 6,
              color: U.iconColor,
              bgColor: "transparent",
              onClick: q,
              icon: /* @__PURE__ */ e(br, {}),
              _disabled: { opacity: 0.5 },
              isDisabled: s === 0,
              "aria-label": t.previousProduct,
              _hover: { bgColor: "transparent" },
              _active: { bgColor: "transparent" },
              "data-ph-capture-attribute-tracking-id": "upsell-carousel-previous-button"
            }
          ),
          /* @__PURE__ */ d(b, { color: "var(--text-secondary, #585858)", fontSize: "xs", children: [
            s + 1,
            " / ",
            C.length
          ] }),
          /* @__PURE__ */ e(
            pt,
            {
              w: 6,
              h: 6,
              color: U.iconColor,
              onClick: J,
              bgColor: "transparent",
              icon: /* @__PURE__ */ e(gr, {}),
              _disabled: { opacity: 0.5 },
              "aria-label": t.nextProduct,
              _hover: { bgColor: "transparent" },
              _active: { bgColor: "transparent" },
              isDisabled: s === C.length - 1,
              "data-ph-capture-attribute-tracking-id": "upsell-carousel-next-button"
            }
          )
        ] })
      ]
    }
  );
};
export {
  Ha as Body,
  je as BoxGradient,
  He as Button,
  _n as CHECKOUT_THEMES,
  ja as Caption,
  Sa as Card,
  Ba as Cart,
  za as Confirm,
  dt as DEFAULT_CHECKOUT_THEME,
  $a as DisplaySwitcher,
  Wa as Heading,
  Ua as Info,
  Mt as Input,
  Ea as InputRhf,
  Rt as InputWithIcon,
  Ca as InputWithIconRhf,
  $n as JustDrawer,
  Ta as JustSkeleton,
  Ga as JustToast,
  va as LeafThemeProvider,
  Da as MobileSelect,
  wa as PhoneInput,
  Aa as PinInput,
  Ia as PlaceholderDropdown,
  _a as PlaceholderDropdownCard,
  Xn as ProductSkeleton,
  ka as Radio,
  Ra as UpsellCarousel,
  xa as getCustomThemeOverrides,
  ha as getThemeByName,
  fa as getThemeCssVariables,
  ya as isValidCheckoutTheme,
  Ut as theme,
  Un as useJustDrawer,
  ae as useLeafTheme
};
